//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class ApiService {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:7010/api";

    }

    /**
     * @param reduced (optional) 
     * @return Payload of AgreementDto
     */
    getAgreementById(id: string, reduced: boolean | undefined, cancelToken?: CancelToken): Promise<AgreementDto> {
        let url_ = this.baseUrl + "/agreement/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reduced === null)
            throw new Error("The parameter 'reduced' cannot be null.");
        else if (reduced !== undefined)
            url_ += "reduced=" + encodeURIComponent("" + reduced) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementById(_response);
        });
    }

    protected processGetAgreementById(response: AxiosResponse): Promise<AgreementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementDto.fromJS(resultData200);
            return Promise.resolve<AgreementDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementDto>(null as any);
    }

    /**
     * @return Payload of AgreementCustomerSummary
     */
    getAgreementSummaryById(id: string, cancelToken?: CancelToken): Promise<AgreementCustomerSummary> {
        let url_ = this.baseUrl + "/agreement/{id}/customer-summary";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementSummaryById(_response);
        });
    }

    protected processGetAgreementSummaryById(response: AxiosResponse): Promise<AgreementCustomerSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementCustomerSummary.fromJS(resultData200);
            return Promise.resolve<AgreementCustomerSummary>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementCustomerSummary>(null as any);
    }

    /**
     * @param status (optional) Kind of agreements. Possible values: tender, agreement, expired
     * @param reduced (optional) 
     * @return Payload of AgreementListViewDtoWrapper
     */
    getAgreements(status: string | undefined, reduced: boolean | undefined, cancelToken?: CancelToken): Promise<AgreementListViewDtoWrapper> {
        let url_ = this.baseUrl + "/agreement?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (reduced === null)
            throw new Error("The parameter 'reduced' cannot be null.");
        else if (reduced !== undefined)
            url_ += "reduced=" + encodeURIComponent("" + reduced) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreements(_response);
        });
    }

    protected processGetAgreements(response: AxiosResponse): Promise<AgreementListViewDtoWrapper> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementListViewDtoWrapper.fromJS(resultData200);
            return Promise.resolve<AgreementListViewDtoWrapper>(result200);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementListViewDtoWrapper>(null as any);
    }

    /**
     * @return Payload of AgreementsWithSuppliersResponse
     */
    getAgreementsWithSuppliers( cancelToken?: CancelToken): Promise<AgreementsWithSuppliersResponse> {
        let url_ = this.baseUrl + "/agreements-with-suppliers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementsWithSuppliers(_response);
        });
    }

    protected processGetAgreementsWithSuppliers(response: AxiosResponse): Promise<AgreementsWithSuppliersResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementsWithSuppliersResponse.fromJS(resultData200);
            return Promise.resolve<AgreementsWithSuppliersResponse>(result200);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = ProblemDetails.fromJS(resultData500);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result500);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementsWithSuppliersResponse>(null as any);
    }

    /**
     * @return Payload of Array of FaqListViewDto
     */
    getAgreementFaqs(id: string, cancelToken?: CancelToken): Promise<FaqListViewDto[]> {
        let url_ = this.baseUrl + "/agreement/{id}/faq";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementFaqs(_response);
        });
    }

    protected processGetAgreementFaqs(response: AxiosResponse): Promise<FaqListViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FaqListViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FaqListViewDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FaqListViewDto[]>(null as any);
    }

    /**
     * @return Payload of Array of DescriptionListViewDto
     */
    getAgreementDescriptions(id: string, cancelToken?: CancelToken): Promise<DescriptionListViewDto[]> {
        let url_ = this.baseUrl + "/agreement/{id}/description";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementDescriptions(_response);
        });
    }

    protected processGetAgreementDescriptions(response: AxiosResponse): Promise<DescriptionListViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DescriptionListViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DescriptionListViewDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DescriptionListViewDto[]>(null as any);
    }

    /**
     * @return Payload of StatusupdateListViewDto
     */
    getAgreementStatusUpdate(id: string, cancelToken?: CancelToken): Promise<StatusupdateListViewDto> {
        let url_ = this.baseUrl + "/agreement/{id}/status-update";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementStatusUpdate(_response);
        });
    }

    protected processGetAgreementStatusUpdate(response: AxiosResponse): Promise<StatusupdateListViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusupdateListViewDto.fromJS(resultData200);
            return Promise.resolve<StatusupdateListViewDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusupdateListViewDto>(null as any);
    }

    /**
     * @param guid (optional) If not provided the user needs to be logged in.
     * @return Payload of AgreementListViewDtoWrapper
     */
    getStatusUpdateAgreementsByUserId(guid: string | undefined, cancelToken?: CancelToken): Promise<AgreementListViewDtoWrapper> {
        let url_ = this.baseUrl + "/user/status-update-subscription?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatusUpdateAgreementsByUserId(_response);
        });
    }

    protected processGetStatusUpdateAgreementsByUserId(response: AxiosResponse): Promise<AgreementListViewDtoWrapper> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementListViewDtoWrapper.fromJS(resultData200);
            return Promise.resolve<AgreementListViewDtoWrapper>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result400);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementListViewDtoWrapper>(null as any);
    }

    /**
     * @param guid (optional) If not provided the user needs to be logged in.
     * @param body (optional) The aftaleID of the agreement post
     * @return Payload of StatusUpdateProgress
     */
    durableStatusUpdateFunctionHttpStart(guid: string | undefined, body: StatusUpdatesRequest | undefined, cancelToken?: CancelToken): Promise<StatusUpdateProgress> {
        let url_ = this.baseUrl + "/user/status-update-subscription?";
        if (guid === null)
            throw new Error("The parameter 'guid' cannot be null.");
        else if (guid !== undefined)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDurableStatusUpdateFunctionHttpStart(_response);
        });
    }

    protected processDurableStatusUpdateFunctionHttpStart(response: AxiosResponse): Promise<StatusUpdateProgress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 202) {
            const _responseText = response.data;
            let result202: any = null;
            let resultData202  = _responseText;
            result202 = StatusUpdateProgress.fromJS(resultData202);
            return Promise.resolve<StatusUpdateProgress>(result202);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusUpdateProgress>(null as any);
    }

    /**
     * @return Payload of Array of AgreementSearchDto
     */
    getAgreementsSearchData( cancelToken?: CancelToken): Promise<AgreementSearchDto[]> {
        let url_ = this.baseUrl + "/agreement-search";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementsSearchData(_response);
        });
    }

    protected processGetAgreementsSearchData(response: AxiosResponse): Promise<AgreementSearchDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AgreementSearchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AgreementSearchDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementSearchDto[]>(null as any);
    }

    /**
     * @return Payload of Array of CustomerListApplicationViewDto
     */
    getAgreementsCustomerList(id: string, cancelToken?: CancelToken): Promise<CustomerListApplicationViewDto[]> {
        let url_ = this.baseUrl + "/agreement/{id}/customer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementsCustomerList(_response);
        });
    }

    protected processGetAgreementsCustomerList(response: AxiosResponse): Promise<CustomerListApplicationViewDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerListApplicationViewDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerListApplicationViewDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerListApplicationViewDto[]>(null as any);
    }

    /**
     * @param reduced (optional) 
     * @return Payload of SupplierListViewDtoWrapper
     */
    getAgreementsSupplierList(id: string, reduced: boolean | undefined, cancelToken?: CancelToken): Promise<SupplierListViewDtoWrapper> {
        let url_ = this.baseUrl + "/agreement/{id}/supplier?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reduced === null)
            throw new Error("The parameter 'reduced' cannot be null.");
        else if (reduced !== undefined)
            url_ += "reduced=" + encodeURIComponent("" + reduced) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementsSupplierList(_response);
        });
    }

    protected processGetAgreementsSupplierList(response: AxiosResponse): Promise<SupplierListViewDtoWrapper> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SupplierListViewDtoWrapper.fromJS(resultData200);
            return Promise.resolve<SupplierListViewDtoWrapper>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupplierListViewDtoWrapper>(null as any);
    }

    /**
     * @param include (optional) List of properties to be included in the response
     * @param exclude_subagreements (optional) Bool value that indicates if subagreements should be excluded in the response
     * @return Payload of String
     */
    getCriticalAftaleDatoer(include: string | undefined, exclude_subagreements: string | undefined, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/agreement-calendar?";
        if (include === null)
            throw new Error("The parameter 'include' cannot be null.");
        else if (include !== undefined)
            url_ += "include=" + encodeURIComponent("" + include) + "&";
        if (exclude_subagreements === null)
            throw new Error("The parameter 'exclude_subagreements' cannot be null.");
        else if (exclude_subagreements !== undefined)
            url_ += "exclude-subagreements=" + encodeURIComponent("" + exclude_subagreements) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCriticalAftaleDatoer(_response);
        });
    }

    protected processGetCriticalAftaleDatoer(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @return Payload of GetContactsForOrganizationResponse
     */
    getContactsForOrganization(orgId: string, cancelToken?: CancelToken): Promise<GetContactsForOrganizationResponse> {
        let url_ = this.baseUrl + "/contact?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined and cannot be null.");
        else
            url_ += "orgId=" + encodeURIComponent("" + orgId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContactsForOrganization(_response);
        });
    }

    protected processGetContactsForOrganization(response: AxiosResponse): Promise<GetContactsForOrganizationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetContactsForOrganizationResponse.fromJS(resultData200);
            return Promise.resolve<GetContactsForOrganizationResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetContactsForOrganizationResponse>(null as any);
    }

    /**
     * @param modifiedFrom (optional) 
     * @param modifiedTo (optional) 
     * @return Payload of GetDispensationResponse
     */
    getDispensations(modifiedFrom: Date | undefined, modifiedTo: Date | undefined, cancelToken?: CancelToken): Promise<GetDispensationResponse> {
        let url_ = this.baseUrl + "/dispensation?";
        if (modifiedFrom === null)
            throw new Error("The parameter 'modifiedFrom' cannot be null.");
        else if (modifiedFrom !== undefined)
            url_ += "modifiedFrom=" + encodeURIComponent(modifiedFrom ? "" + modifiedFrom.toISOString() : "") + "&";
        if (modifiedTo === null)
            throw new Error("The parameter 'modifiedTo' cannot be null.");
        else if (modifiedTo !== undefined)
            url_ += "modifiedTo=" + encodeURIComponent(modifiedTo ? "" + modifiedTo.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDispensations(_response);
        });
    }

    protected processGetDispensations(response: AxiosResponse): Promise<GetDispensationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetDispensationResponse.fromJS(resultData200);
            return Promise.resolve<GetDispensationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result403);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetDispensationResponse>(null as any);
    }

    /**
     * @return Payload of Array of Byte
     */
    getDocumentById(id: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/document/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDocumentById(_response);
        });
    }

    protected processGetDocumentById(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result404);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @return Payload of Array of EmployeeListViewDtoWrapper
     */
    getEmployeeById(id: string, cancelToken?: CancelToken): Promise<EmployeeListViewDtoWrapper[]> {
        let url_ = this.baseUrl + "/employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeById(_response);
        });
    }

    protected processGetEmployeeById(response: AxiosResponse): Promise<EmployeeListViewDtoWrapper[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeListViewDtoWrapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeListViewDtoWrapper[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeListViewDtoWrapper[]>(null as any);
    }

    /**
     * @return Payload of EmployeeListViewDtoWrapper
     */
    getEmployees( cancelToken?: CancelToken): Promise<EmployeeListViewDtoWrapper> {
        let url_ = this.baseUrl + "/employee";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<EmployeeListViewDtoWrapper> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeListViewDtoWrapper.fromJS(resultData200);
            return Promise.resolve<EmployeeListViewDtoWrapper>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeListViewDtoWrapper>(null as any);
    }

    /**
     * @return Payload of HealthCheckResult
     */
    healthcheck( cancelToken?: CancelToken): Promise<HealthCheckResult> {
        let url_ = this.baseUrl + "/healthcheck";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHealthcheck(_response);
        });
    }

    protected processHealthcheck(response: AxiosResponse): Promise<HealthCheckResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HealthCheckResult.fromJS(resultData200);
            return Promise.resolve<HealthCheckResult>(result200);

        } else if (status === 503) {
            const _responseText = response.data;
            let result503: any = null;
            let resultData503  = _responseText;
            result503 = ProblemDetails.fromJS(resultData503);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result503);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HealthCheckResult>(null as any);
    }

    /**
     * @param reduced (optional) 
     * @param agreementIds (optional) 
     * @return Payload of OrganizationListViewDto
     */
    getOrganizationById(id: string, reduced: boolean | undefined, agreementIds: string[] | undefined, cancelToken?: CancelToken): Promise<OrganizationListViewDto> {
        let url_ = this.baseUrl + "/organization/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reduced === null)
            throw new Error("The parameter 'reduced' cannot be null.");
        else if (reduced !== undefined)
            url_ += "reduced=" + encodeURIComponent("" + reduced) + "&";
        if (agreementIds === null)
            throw new Error("The parameter 'agreementIds' cannot be null.");
        else if (agreementIds !== undefined)
            agreementIds && agreementIds.forEach(item => { url_ += "agreementIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationById(_response);
        });
    }

    protected processGetOrganizationById(response: AxiosResponse): Promise<OrganizationListViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationListViewDto.fromJS(resultData200);
            return Promise.resolve<OrganizationListViewDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationListViewDto>(null as any);
    }

    /**
     * @param fromRoot (optional) 
     * @param disableUserMgmtFilter (optional) Determines if organizations without SkiSynligIbrugerstyring should be shown
     * @return Payload of OrganizationStructureDto
     */
    getOrganizationStructure(id: string, fromRoot: boolean | undefined, disableUserMgmtFilter: boolean | undefined, cancelToken?: CancelToken): Promise<OrganizationStructureDto> {
        let url_ = this.baseUrl + "/organization/{id}/structure?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (fromRoot === null)
            throw new Error("The parameter 'fromRoot' cannot be null.");
        else if (fromRoot !== undefined)
            url_ += "fromRoot=" + encodeURIComponent("" + fromRoot) + "&";
        if (disableUserMgmtFilter === null)
            throw new Error("The parameter 'disableUserMgmtFilter' cannot be null.");
        else if (disableUserMgmtFilter !== undefined)
            url_ += "disableUserMgmtFilter=" + encodeURIComponent("" + disableUserMgmtFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationStructure(_response);
        });
    }

    protected processGetOrganizationStructure(response: AxiosResponse): Promise<OrganizationStructureDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationStructureDto.fromJS(resultData200);
            return Promise.resolve<OrganizationStructureDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationStructureDto>(null as any);
    }

    /**
     * @param q What period the organizations agreements should report on
     * @param role (optional) What role the organizations should have, must be
     * @param expand (optional) What expanded data should be shown
     * @return Payload of Array of OrganizationDto
     */
    getOrganizations(q: string, role: string | undefined, expand: string | undefined, cancelToken?: CancelToken): Promise<OrganizationDto[]> {
        let url_ = this.baseUrl + "/organization?";
        if (q === undefined || q === null)
            throw new Error("The parameter 'q' must be defined and cannot be null.");
        else
            url_ += "q=" + encodeURIComponent("" + q) + "&";
        if (role === null)
            throw new Error("The parameter 'role' cannot be null.");
        else if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        if (expand === null)
            throw new Error("The parameter 'expand' cannot be null.");
        else if (expand !== undefined)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizations(_response);
        });
    }

    protected processGetOrganizations(response: AxiosResponse): Promise<OrganizationDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationDto[]>(null as any);
    }

    /**
     * @param orgIds (optional) 
     * @return Payload of Array of OrganizationSearchDto
     */
    getOrganizationSearchData(orgIds: string[] | undefined, cancelToken?: CancelToken): Promise<OrganizationSearchDto[]> {
        let url_ = this.baseUrl + "/organization-search?";
        if (orgIds === null)
            throw new Error("The parameter 'orgIds' cannot be null.");
        else if (orgIds !== undefined)
            orgIds && orgIds.forEach(item => { url_ += "orgIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationSearchData(_response);
        });
    }

    protected processGetOrganizationSearchData(response: AxiosResponse): Promise<OrganizationSearchDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationSearchDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationSearchDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationSearchDto[]>(null as any);
    }

    /**
     * @return Payload of Array of CustomerListDtoWrapper
     */
    getOrganizationCustomerList(id: string, cancelToken?: CancelToken): Promise<CustomerListDtoWrapper[]> {
        let url_ = this.baseUrl + "/organization/{id}/customer";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationCustomerList(_response);
        });
    }

    protected processGetOrganizationCustomerList(response: AxiosResponse): Promise<CustomerListDtoWrapper[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerListDtoWrapper.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerListDtoWrapper[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerListDtoWrapper[]>(null as any);
    }

    /**
     * @return Payload of AgreementDto
     */
    getOrganizationAgreement(agreementId: string, orgId: string, cancelToken?: CancelToken): Promise<AgreementDto> {
        let url_ = this.baseUrl + "/organization/{orgId}/agreement/{agreementId}";
        if (agreementId === undefined || agreementId === null)
            throw new Error("The parameter 'agreementId' must be defined.");
        url_ = url_.replace("{agreementId}", encodeURIComponent("" + agreementId));
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationAgreement(_response);
        });
    }

    protected processGetOrganizationAgreement(response: AxiosResponse): Promise<AgreementDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AgreementDto.fromJS(resultData200);
            return Promise.resolve<AgreementDto>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result401);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AgreementDto>(null as any);
    }

    /**
     * @param action What shall happen to the supplierreport(s) on the agreement
     * @param enddate When the supplierreport(s) shall end
     * @return Payload of String
     */
    terminateSupplierReports(aftId: string, orgId: string, action: string, enddate: Date, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/organization/{orgId}/agreement/{aftId}/report?";
        if (aftId === undefined || aftId === null)
            throw new Error("The parameter 'aftId' must be defined.");
        url_ = url_.replace("{aftId}", encodeURIComponent("" + aftId));
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (action === undefined || action === null)
            throw new Error("The parameter 'action' must be defined and cannot be null.");
        else
            url_ += "action=" + encodeURIComponent("" + action) + "&";
        if (enddate === undefined || enddate === null)
            throw new Error("The parameter 'enddate' must be defined and cannot be null.");
        else
            url_ += "enddate=" + encodeURIComponent(enddate ? "" + enddate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTerminateSupplierReports(_response);
        });
    }

    protected processTerminateSupplierReports(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204: any = null;
            let resultData204  = _responseText;
                result204 = resultData204 !== undefined ? resultData204 : <any>null;
    
            return Promise.resolve<string>(result204);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
                result401 = resultData401 !== undefined ? resultData401 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result401);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
                result403 = resultData403 !== undefined ? resultData403 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param endDateAfter (optional) Henter aftaler med indrapporteringsaftaler med slutdato efter denne dato
     * @return Payload of OrganizationAgreementList
     */
    getOrganizationAgreementList(orgId: string, endDateAfter: Date | undefined, cancelToken?: CancelToken): Promise<OrganizationAgreementList> {
        let url_ = this.baseUrl + "/organization/{orgId}/supplier-agreement?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (endDateAfter === null)
            throw new Error("The parameter 'endDateAfter' cannot be null.");
        else if (endDateAfter !== undefined)
            url_ += "endDateAfter=" + encodeURIComponent(endDateAfter ? "" + endDateAfter.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOrganizationAgreementList(_response);
        });
    }

    protected processGetOrganizationAgreementList(response: AxiosResponse): Promise<OrganizationAgreementList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OrganizationAgreementList.fromJS(resultData200);
            return Promise.resolve<OrganizationAgreementList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationAgreementList>(null as any);
    }

    /**
     * @param orgIds (optional) Filter result by organization ids. (orgIds and orgType are mutually exclusive parameters)
     * @param orgType (optional) Filter by organization type. Can be either the integer value or type name. (orgIds and orgType are mutually exclusive parameters)
     * @param disableUserMgmtFilter (optional) Determines if organizations without SkiSynligIbrugerstyring should be shown
     * @return Payload of Array of OrganizationStructureDto
     */
    getFilteredOrganizationList(orgIds: string[] | undefined, orgType: string | undefined, disableUserMgmtFilter: boolean | undefined, cancelToken?: CancelToken): Promise<OrganizationStructureDto[]> {
        let url_ = this.baseUrl + "/organization/search/filtered-organizationlist?";
        if (orgIds === null)
            throw new Error("The parameter 'orgIds' cannot be null.");
        else if (orgIds !== undefined)
            orgIds && orgIds.forEach(item => { url_ += "orgIds=" + encodeURIComponent("" + item) + "&"; });
        if (orgType === null)
            throw new Error("The parameter 'orgType' cannot be null.");
        else if (orgType !== undefined)
            url_ += "orgType=" + encodeURIComponent("" + orgType) + "&";
        if (disableUserMgmtFilter === null)
            throw new Error("The parameter 'disableUserMgmtFilter' cannot be null.");
        else if (disableUserMgmtFilter !== undefined)
            url_ += "disableUserMgmtFilter=" + encodeURIComponent("" + disableUserMgmtFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFilteredOrganizationList(_response);
        });
    }

    protected processGetFilteredOrganizationList(response: AxiosResponse): Promise<OrganizationStructureDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationStructureDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationStructureDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationStructureDto[]>(null as any);
    }

    /**
     * @return Payload of Array of OrganizationRelationSummaryDto
     */
    getRelatedOrganizations(orgId: string, orgRelationNames: string[], cancelToken?: CancelToken): Promise<OrganizationRelationSummaryDto[]> {
        let url_ = this.baseUrl + "/organization/{orgId}/related-organizations?";
        if (orgId === undefined || orgId === null)
            throw new Error("The parameter 'orgId' must be defined.");
        url_ = url_.replace("{orgId}", encodeURIComponent("" + orgId));
        if (orgRelationNames === undefined || orgRelationNames === null)
            throw new Error("The parameter 'orgRelationNames' must be defined and cannot be null.");
        else
            orgRelationNames && orgRelationNames.forEach(item => { url_ += "orgRelationNames=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRelatedOrganizations(_response);
        });
    }

    protected processGetRelatedOrganizations(response: AxiosResponse): Promise<OrganizationRelationSummaryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OrganizationRelationSummaryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OrganizationRelationSummaryDto[]>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OrganizationRelationSummaryDto[]>(null as any);
    }

    /**
     * @param modifiedAfter The date and time to filter modified organizations. This must be in UTC format.
     * @return Payload of GetInvoiceEligibleOrgResponse
     */
    getInvoiceEligibleOrg(modifiedAfter: Date, cancelToken?: CancelToken): Promise<GetInvoiceEligibleOrgResponse> {
        let url_ = this.baseUrl + "/organization-invoice-details?";
        if (modifiedAfter === undefined || modifiedAfter === null)
            throw new Error("The parameter 'modifiedAfter' must be defined and cannot be null.");
        else
            url_ += "modifiedAfter=" + encodeURIComponent(modifiedAfter ? "" + modifiedAfter.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoiceEligibleOrg(_response);
        });
    }

    protected processGetInvoiceEligibleOrg(response: AxiosResponse): Promise<GetInvoiceEligibleOrgResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetInvoiceEligibleOrgResponse.fromJS(resultData200);
            return Promise.resolve<GetInvoiceEligibleOrgResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("Payload of ProblemDetails", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetInvoiceEligibleOrgResponse>(null as any);
    }

    /**
     * @return Payload of StatusUpdateViewDto
     */
    getAgreementStatusUpdateById(id: string, cancelToken?: CancelToken): Promise<StatusUpdateViewDto> {
        let url_ = this.baseUrl + "/status-update/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAgreementStatusUpdateById(_response);
        });
    }

    protected processGetAgreementStatusUpdateById(response: AxiosResponse): Promise<StatusUpdateViewDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusUpdateViewDto.fromJS(resultData200);
            return Promise.resolve<StatusUpdateViewDto>(result200);

        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusUpdateViewDto>(null as any);
    }

    /**
     * @param body (optional) The aftaleID of the agreement post
     * @return No description
     */
    postUserSubscriptionToStatusUpdate(id: string, body: SkiAgreementRequest | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/user/{id}/status-update-subscription";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPostUserSubscriptionToStatusUpdate(_response);
        });
    }

    protected processPostUserSubscriptionToStatusUpdate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("No description", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return Payload of Array of SupplierWithAgreement
     */
    getSuppliersWhoMustReportInPeriod(startDate: Date, endDate: Date, cancelToken?: CancelToken): Promise<SupplierWithAgreement[]> {
        let url_ = this.baseUrl + "/organization/supplier-agreement/reporting-suppliers?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSuppliersWhoMustReportInPeriod(_response);
        });
    }

    protected processGetSuppliersWhoMustReportInPeriod(response: AxiosResponse): Promise<SupplierWithAgreement[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SupplierWithAgreement.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SupplierWithAgreement[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SupplierWithAgreement[]>(null as any);
    }

    /**
     * @param agreementid (optional) 8-digit id for the SKI agreement or tender (e.g. 50480022)
     * @param orgid (optional) Customer company id (e.g. 35300400)
     * @return Payload of Array of TrafficLightOutputDto
     */
    getTrafficLight(agreementid: string | undefined, orgid: string | undefined, cancelToken?: CancelToken): Promise<TrafficLightOutputDto[]> {
        let url_ = this.baseUrl + "/agreement-application?";
        if (agreementid === null)
            throw new Error("The parameter 'agreementid' cannot be null.");
        else if (agreementid !== undefined)
            url_ += "agreementid=" + encodeURIComponent("" + agreementid) + "&";
        if (orgid === null)
            throw new Error("The parameter 'orgid' cannot be null.");
        else if (orgid !== undefined)
            url_ += "orgid=" + encodeURIComponent("" + orgid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTrafficLight(_response);
        });
    }

    protected processGetTrafficLight(response: AxiosResponse): Promise<TrafficLightOutputDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TrafficLightOutputDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TrafficLightOutputDto[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
                result404 = resultData404 !== undefined ? resultData404 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result404);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
                result400 = resultData400 !== undefined ? resultData400 : <any>null;
    
            return throwException("Payload of String", status, _responseText, _headers, result400);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrafficLightOutputDto[]>(null as any);
    }

    /**
     * @param id This is the email or guid of the person and is used as unique identifier.
     * @return Payload of StatusUpdateProgress
     */
    getStatus(id: string, cancelToken?: CancelToken): Promise<StatusUpdateProgress> {
        let url_ = this.baseUrl + "/user/{id}/status-update-subscription/task";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<StatusUpdateProgress> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusUpdateProgress.fromJS(resultData200);
            return Promise.resolve<StatusUpdateProgress>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusUpdateProgress>(null as any);
    }
}

export class Agreement implements IAgreement {
    agreementId?: string;
    name?: string;
    displayNameShort?: string;
    displayNameLong?: string;
    combinedAgreementNumber?: string;
    overallStatusName?: string;
    intoForceDateUtc?: string;
    expectedIntoForceDateStartUtc?: string;
    expirationDateUtc?: string;
    eCatalogOnAgreement?: boolean;
    url?: string;
    suppliers?: Supplier[];

    [key: string]: any;

    constructor(data?: IAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.name = _data["name"];
            this.displayNameShort = _data["displayNameShort"];
            this.displayNameLong = _data["displayNameLong"];
            this.combinedAgreementNumber = _data["combinedAgreementNumber"];
            this.overallStatusName = _data["overallStatusName"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.expectedIntoForceDateStartUtc = _data["expectedIntoForceDateStartUtc"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.eCatalogOnAgreement = _data["eCatalogOnAgreement"];
            this.url = _data["url"];
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(Supplier.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Agreement {
        data = typeof data === 'object' ? data : {};
        let result = new Agreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["name"] = this.name;
        data["displayNameShort"] = this.displayNameShort;
        data["displayNameLong"] = this.displayNameLong;
        data["combinedAgreementNumber"] = this.combinedAgreementNumber;
        data["overallStatusName"] = this.overallStatusName;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["expectedIntoForceDateStartUtc"] = this.expectedIntoForceDateStartUtc;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["eCatalogOnAgreement"] = this.eCatalogOnAgreement;
        data["url"] = this.url;
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgreement {
    agreementId?: string;
    name?: string;
    displayNameShort?: string;
    displayNameLong?: string;
    combinedAgreementNumber?: string;
    overallStatusName?: string;
    intoForceDateUtc?: string;
    expectedIntoForceDateStartUtc?: string;
    expirationDateUtc?: string;
    eCatalogOnAgreement?: boolean;
    url?: string;
    suppliers?: Supplier[];

    [key: string]: any;
}

export class AgreementCustomerSummary implements IAgreementCustomerSummary {
    agreementId?: string;
    endDateUtc?: Date;
    terminationDateUtc?: Date;
    subAgreementSummary?: AgreementCustomerSummary[];

    [key: string]: any;

    constructor(data?: IAgreementCustomerSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.endDateUtc = _data["endDateUtc"] ? new Date(_data["endDateUtc"].toString()) : <any>undefined;
            this.terminationDateUtc = _data["terminationDateUtc"] ? new Date(_data["terminationDateUtc"].toString()) : <any>undefined;
            if (Array.isArray(_data["subAgreementSummary"])) {
                this.subAgreementSummary = [] as any;
                for (let item of _data["subAgreementSummary"])
                    this.subAgreementSummary!.push(AgreementCustomerSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementCustomerSummary {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementCustomerSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["endDateUtc"] = this.endDateUtc ? this.endDateUtc.toISOString() : <any>undefined;
        data["terminationDateUtc"] = this.terminationDateUtc ? this.terminationDateUtc.toISOString() : <any>undefined;
        if (Array.isArray(this.subAgreementSummary)) {
            data["subAgreementSummary"] = [];
            for (let item of this.subAgreementSummary)
                data["subAgreementSummary"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgreementCustomerSummary {
    agreementId?: string;
    endDateUtc?: Date;
    terminationDateUtc?: Date;
    subAgreementSummary?: AgreementCustomerSummary[];

    [key: string]: any;
}

export class AgreementDescriptionShortcutsDto implements IAgreementDescriptionShortcutsDto {
    descriptionName?: string;
    showShortcut?: boolean | undefined;

    [key: string]: any;

    constructor(data?: IAgreementDescriptionShortcutsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.descriptionName = _data["descriptionName"];
            this.showShortcut = _data["showShortcut"];
        }
    }

    static fromJS(data: any): AgreementDescriptionShortcutsDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDescriptionShortcutsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["descriptionName"] = this.descriptionName;
        data["showShortcut"] = this.showShortcut;
        return data;
    }
}

export interface IAgreementDescriptionShortcutsDto {
    descriptionName?: string;
    showShortcut?: boolean | undefined;

    [key: string]: any;
}

export class AgreementDocumentsListViewDto implements IAgreementDocumentsListViewDto {
    agreementId?: string;
    documentId?: string;
    fileName?: string;
    accordionName?: string;
    documentType?: string;
    url?: string;
    documentTypeSortingNumber?: number | undefined;
    sortingNumber?: number | undefined;
    requiresLogin?: boolean;
    userAccess?: DocumentAuthorization;
    includeInScanner?: boolean;

    [key: string]: any;

    constructor(data?: IAgreementDocumentsListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.documentId = _data["documentId"];
            this.fileName = _data["fileName"];
            this.accordionName = _data["accordionName"];
            this.documentType = _data["documentType"];
            this.url = _data["url"];
            this.documentTypeSortingNumber = _data["documentTypeSortingNumber"];
            this.sortingNumber = _data["sortingNumber"];
            this.requiresLogin = _data["requiresLogin"];
            this.userAccess = _data["userAccess"] ? DocumentAuthorization.fromJS(_data["userAccess"]) : <any>undefined;
            this.includeInScanner = _data["includeInScanner"];
        }
    }

    static fromJS(data: any): AgreementDocumentsListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDocumentsListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["documentId"] = this.documentId;
        data["fileName"] = this.fileName;
        data["accordionName"] = this.accordionName;
        data["documentType"] = this.documentType;
        data["url"] = this.url;
        data["documentTypeSortingNumber"] = this.documentTypeSortingNumber;
        data["sortingNumber"] = this.sortingNumber;
        data["requiresLogin"] = this.requiresLogin;
        data["userAccess"] = this.userAccess ? this.userAccess.toJSON() : <any>undefined;
        data["includeInScanner"] = this.includeInScanner;
        return data;
    }
}

export interface IAgreementDocumentsListViewDto {
    agreementId?: string;
    documentId?: string;
    fileName?: string;
    accordionName?: string;
    documentType?: string;
    url?: string;
    documentTypeSortingNumber?: number | undefined;
    sortingNumber?: number | undefined;
    requiresLogin?: boolean;
    userAccess?: DocumentAuthorization;
    includeInScanner?: boolean;

    [key: string]: any;
}

export class AgreementDto implements IAgreementDto {
    mainAgreementName?: string;
    mainAgreementId?: string;
    agreementNumber?: string;
    status?: string;
    finalDateUtc?: string;
    externalLink?: string;
    agreementMainNumber?: string;
    guid?: string | undefined;
    type?: string;
    intoForceDateUtc?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    group?: string;
    agreementYearNumber?: string;
    displayNameLong?: string;
    agreementSubNumber?: string;
    displayNameShort?: string;
    expirationDateUtc?: string;
    previewDateUtc?: string;
    tenderProcess?: string;
    expirationDateMaxUtc?: string;
    link?: string;
    phase?: string;
    displayNumbers?: string;
    overallStatusName?: string;
    origin?: string;
    catalogue?: boolean;
    orderCatalogue?: boolean;
    greenCatalogue?: boolean;
    eCatalogOnAgreement?: boolean | undefined;
    expirationDateCest?: string;
    expirationDateMaxCest?: string;
    finalDateCest?: string;
    hideSupplierAccordion?: boolean;
    textForSuppliers?: string;
    textForCustomers?: string;
    option?: CrmSkiExtensionListViewDto[];
    responsibles?: SkiResponsibleListViewDto[];
    subAgreement?: SubagreementListViewDto[];
    projectGroup?: ProjectGroupListViewDto[];
    calendar?: CalendarListItemDto[];
    document?: AgreementDocumentsListViewDto[];
    successors?: AgreementReplacesListViewDto[];
    presuccessors?: AgreementReplacesListViewDto[];
    supplierList?: SupplierListViewDto[];
    customerApplication?: CustomerApplicationListViewDto;
    relatedAgreements?: RelatedAgreementsListViewDto[];
    keywords?: KeywordDto[];
    greenFilters?: GreenFilterDto[];
    approvals?: SkiApprovalsListViewDto[];
    descriptionShortcuts?: AgreementDescriptionShortcutsDto[];
    id?: string;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationDate?: Date | undefined;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;

    constructor(data?: IAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.mainAgreementName = _data["mainAgreementName"];
            this.mainAgreementId = _data["mainAgreementId"];
            this.agreementNumber = _data["agreementNumber"];
            this.status = _data["status"];
            this.finalDateUtc = _data["finalDateUtc"];
            this.externalLink = _data["externalLink"];
            this.agreementMainNumber = _data["agreementMainNumber"];
            this.guid = _data["guid"];
            this.type = _data["type"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.expectedIntoForceAlternateDisplayDate = _data["expectedIntoForceAlternateDisplayDate"];
            this.expectedIntoForceStartDateUtc = _data["expectedIntoForceStartDateUtc"];
            this.group = _data["group"];
            this.agreementYearNumber = _data["agreementYearNumber"];
            this.displayNameLong = _data["displayNameLong"];
            this.agreementSubNumber = _data["agreementSubNumber"];
            this.displayNameShort = _data["displayNameShort"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.previewDateUtc = _data["previewDateUtc"];
            this.tenderProcess = _data["tenderProcess"];
            this.expirationDateMaxUtc = _data["expirationDateMaxUtc"];
            this.link = _data["link"];
            this.phase = _data["phase"];
            this.displayNumbers = _data["displayNumbers"];
            this.overallStatusName = _data["overallStatusName"];
            this.origin = _data["origin"];
            this.catalogue = _data["catalogue"];
            this.orderCatalogue = _data["orderCatalogue"];
            this.greenCatalogue = _data["greenCatalogue"];
            this.eCatalogOnAgreement = _data["eCatalogOnAgreement"];
            this.expirationDateCest = _data["expirationDateCest"];
            this.expirationDateMaxCest = _data["expirationDateMaxCest"];
            this.finalDateCest = _data["finalDateCest"];
            this.hideSupplierAccordion = _data["hideSupplierAccordion"];
            this.textForSuppliers = _data["textForSuppliers"];
            this.textForCustomers = _data["textForCustomers"];
            if (Array.isArray(_data["option"])) {
                this.option = [] as any;
                for (let item of _data["option"])
                    this.option!.push(CrmSkiExtensionListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["responsibles"])) {
                this.responsibles = [] as any;
                for (let item of _data["responsibles"])
                    this.responsibles!.push(SkiResponsibleListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["subAgreement"])) {
                this.subAgreement = [] as any;
                for (let item of _data["subAgreement"])
                    this.subAgreement!.push(SubagreementListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["projectGroup"])) {
                this.projectGroup = [] as any;
                for (let item of _data["projectGroup"])
                    this.projectGroup!.push(ProjectGroupListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["calendar"])) {
                this.calendar = [] as any;
                for (let item of _data["calendar"])
                    this.calendar!.push(CalendarListItemDto.fromJS(item));
            }
            if (Array.isArray(_data["document"])) {
                this.document = [] as any;
                for (let item of _data["document"])
                    this.document!.push(AgreementDocumentsListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["successors"])) {
                this.successors = [] as any;
                for (let item of _data["successors"])
                    this.successors!.push(AgreementReplacesListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["presuccessors"])) {
                this.presuccessors = [] as any;
                for (let item of _data["presuccessors"])
                    this.presuccessors!.push(AgreementReplacesListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["supplierList"])) {
                this.supplierList = [] as any;
                for (let item of _data["supplierList"])
                    this.supplierList!.push(SupplierListViewDto.fromJS(item));
            }
            this.customerApplication = _data["customerApplication"] ? CustomerApplicationListViewDto.fromJS(_data["customerApplication"]) : <any>undefined;
            if (Array.isArray(_data["relatedAgreements"])) {
                this.relatedAgreements = [] as any;
                for (let item of _data["relatedAgreements"])
                    this.relatedAgreements!.push(RelatedAgreementsListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            if (Array.isArray(_data["greenFilters"])) {
                this.greenFilters = [] as any;
                for (let item of _data["greenFilters"])
                    this.greenFilters!.push(GreenFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["approvals"])) {
                this.approvals = [] as any;
                for (let item of _data["approvals"])
                    this.approvals!.push(SkiApprovalsListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["descriptionShortcuts"])) {
                this.descriptionShortcuts = [] as any;
                for (let item of _data["descriptionShortcuts"])
                    this.descriptionShortcuts!.push(AgreementDescriptionShortcutsDto.fromJS(item));
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameWithYear = _data["nameWithYear"];
            this.frameworkAgreementAreaNumber = _data["frameworkAgreementAreaNumber"];
            this.frameworkAgreementNumber = _data["frameworkAgreementNumber"];
            this.partialAgreementNumber = _data["partialAgreementNumber"];
            this.frameworkAgreementYear = _data["frameworkAgreementYear"];
            this.combinedAgreementNumber = _data["combinedAgreementNumber"];
            this.agreementId = _data["agreementId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationIncOptionsDate = _data["expirationIncOptionsDate"] ? new Date(_data["expirationIncOptionsDate"].toString()) : <any>undefined;
            this.showDisButton = _data["showDisButton"];
            this.disButtonUrl = _data["disButtonUrl"];
            this.disButtonText = _data["disButtonText"];
        }
    }

    static fromJS(data: any): AgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["mainAgreementName"] = this.mainAgreementName;
        data["mainAgreementId"] = this.mainAgreementId;
        data["agreementNumber"] = this.agreementNumber;
        data["status"] = this.status;
        data["finalDateUtc"] = this.finalDateUtc;
        data["externalLink"] = this.externalLink;
        data["agreementMainNumber"] = this.agreementMainNumber;
        data["guid"] = this.guid;
        data["type"] = this.type;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["expectedIntoForceAlternateDisplayDate"] = this.expectedIntoForceAlternateDisplayDate;
        data["expectedIntoForceStartDateUtc"] = this.expectedIntoForceStartDateUtc;
        data["group"] = this.group;
        data["agreementYearNumber"] = this.agreementYearNumber;
        data["displayNameLong"] = this.displayNameLong;
        data["agreementSubNumber"] = this.agreementSubNumber;
        data["displayNameShort"] = this.displayNameShort;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["previewDateUtc"] = this.previewDateUtc;
        data["tenderProcess"] = this.tenderProcess;
        data["expirationDateMaxUtc"] = this.expirationDateMaxUtc;
        data["link"] = this.link;
        data["phase"] = this.phase;
        data["displayNumbers"] = this.displayNumbers;
        data["overallStatusName"] = this.overallStatusName;
        data["origin"] = this.origin;
        data["catalogue"] = this.catalogue;
        data["orderCatalogue"] = this.orderCatalogue;
        data["greenCatalogue"] = this.greenCatalogue;
        data["eCatalogOnAgreement"] = this.eCatalogOnAgreement;
        data["expirationDateCest"] = this.expirationDateCest;
        data["expirationDateMaxCest"] = this.expirationDateMaxCest;
        data["finalDateCest"] = this.finalDateCest;
        data["hideSupplierAccordion"] = this.hideSupplierAccordion;
        data["textForSuppliers"] = this.textForSuppliers;
        data["textForCustomers"] = this.textForCustomers;
        if (Array.isArray(this.option)) {
            data["option"] = [];
            for (let item of this.option)
                data["option"].push(item.toJSON());
        }
        if (Array.isArray(this.responsibles)) {
            data["responsibles"] = [];
            for (let item of this.responsibles)
                data["responsibles"].push(item.toJSON());
        }
        if (Array.isArray(this.subAgreement)) {
            data["subAgreement"] = [];
            for (let item of this.subAgreement)
                data["subAgreement"].push(item.toJSON());
        }
        if (Array.isArray(this.projectGroup)) {
            data["projectGroup"] = [];
            for (let item of this.projectGroup)
                data["projectGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.calendar)) {
            data["calendar"] = [];
            for (let item of this.calendar)
                data["calendar"].push(item.toJSON());
        }
        if (Array.isArray(this.document)) {
            data["document"] = [];
            for (let item of this.document)
                data["document"].push(item.toJSON());
        }
        if (Array.isArray(this.successors)) {
            data["successors"] = [];
            for (let item of this.successors)
                data["successors"].push(item.toJSON());
        }
        if (Array.isArray(this.presuccessors)) {
            data["presuccessors"] = [];
            for (let item of this.presuccessors)
                data["presuccessors"].push(item.toJSON());
        }
        if (Array.isArray(this.supplierList)) {
            data["supplierList"] = [];
            for (let item of this.supplierList)
                data["supplierList"].push(item.toJSON());
        }
        data["customerApplication"] = this.customerApplication ? this.customerApplication.toJSON() : <any>undefined;
        if (Array.isArray(this.relatedAgreements)) {
            data["relatedAgreements"] = [];
            for (let item of this.relatedAgreements)
                data["relatedAgreements"].push(item.toJSON());
        }
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        if (Array.isArray(this.greenFilters)) {
            data["greenFilters"] = [];
            for (let item of this.greenFilters)
                data["greenFilters"].push(item.toJSON());
        }
        if (Array.isArray(this.approvals)) {
            data["approvals"] = [];
            for (let item of this.approvals)
                data["approvals"].push(item.toJSON());
        }
        if (Array.isArray(this.descriptionShortcuts)) {
            data["descriptionShortcuts"] = [];
            for (let item of this.descriptionShortcuts)
                data["descriptionShortcuts"].push(item.toJSON());
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameWithYear"] = this.nameWithYear;
        data["frameworkAgreementAreaNumber"] = this.frameworkAgreementAreaNumber;
        data["frameworkAgreementNumber"] = this.frameworkAgreementNumber;
        data["partialAgreementNumber"] = this.partialAgreementNumber;
        data["frameworkAgreementYear"] = this.frameworkAgreementYear;
        data["combinedAgreementNumber"] = this.combinedAgreementNumber;
        data["agreementId"] = this.agreementId;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["expirationIncOptionsDate"] = this.expirationIncOptionsDate ? formatDate(this.expirationIncOptionsDate) : <any>undefined;
        data["showDisButton"] = this.showDisButton;
        data["disButtonUrl"] = this.disButtonUrl;
        data["disButtonText"] = this.disButtonText;
        return data;
    }
}

export interface IAgreementDto {
    mainAgreementName?: string;
    mainAgreementId?: string;
    agreementNumber?: string;
    status?: string;
    finalDateUtc?: string;
    externalLink?: string;
    agreementMainNumber?: string;
    guid?: string | undefined;
    type?: string;
    intoForceDateUtc?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    group?: string;
    agreementYearNumber?: string;
    displayNameLong?: string;
    agreementSubNumber?: string;
    displayNameShort?: string;
    expirationDateUtc?: string;
    previewDateUtc?: string;
    tenderProcess?: string;
    expirationDateMaxUtc?: string;
    link?: string;
    phase?: string;
    displayNumbers?: string;
    overallStatusName?: string;
    origin?: string;
    catalogue?: boolean;
    orderCatalogue?: boolean;
    greenCatalogue?: boolean;
    eCatalogOnAgreement?: boolean | undefined;
    expirationDateCest?: string;
    expirationDateMaxCest?: string;
    finalDateCest?: string;
    hideSupplierAccordion?: boolean;
    textForSuppliers?: string;
    textForCustomers?: string;
    option?: CrmSkiExtensionListViewDto[];
    responsibles?: SkiResponsibleListViewDto[];
    subAgreement?: SubagreementListViewDto[];
    projectGroup?: ProjectGroupListViewDto[];
    calendar?: CalendarListItemDto[];
    document?: AgreementDocumentsListViewDto[];
    successors?: AgreementReplacesListViewDto[];
    presuccessors?: AgreementReplacesListViewDto[];
    supplierList?: SupplierListViewDto[];
    customerApplication?: CustomerApplicationListViewDto;
    relatedAgreements?: RelatedAgreementsListViewDto[];
    keywords?: KeywordDto[];
    greenFilters?: GreenFilterDto[];
    approvals?: SkiApprovalsListViewDto[];
    descriptionShortcuts?: AgreementDescriptionShortcutsDto[];
    id?: string;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationDate?: Date | undefined;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;
}

export class AgreementForOrganizationListViewDto implements IAgreementForOrganizationListViewDto {
    id?: string;
    url?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    intoForceDateUtc?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    hearingStarted?: string;
    hearingEnded?: string;
    expectedForceStart?: string;
    signupPeriode?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    displayNumbers?: string;
    phase?: string;
    overallStatusName?: string;
    latestStatusUpdateUtc?: Date | undefined;
    group?: string;
    mainAgreementName?: string;
    mainAgreementId?: string;
    isConsortiumAgreement?: boolean;
    sourcingPrograms?: SourcingprogramListViewDto[];
    customerApplication?: CustomerApplicationListViewDto[];
    intoForceDate?: Date | undefined;
    expirationDate?: Date | undefined;
    contactPerson?: ContactPersonOrganizationListViewDto[];
    supplierReporteportingCodes?: number[];
    supplierReports?: SupplierReportDto[];
    terminationDate?: Date | undefined;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;

    constructor(data?: IAgreementForOrganizationListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.url = _data["url"];
            this.displayNameLong = _data["displayNameLong"];
            this.displayNameShort = _data["displayNameShort"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.expirationDateMaxUtc = _data["expirationDateMaxUtc"];
            this.hearingStarted = _data["hearingStarted"];
            this.hearingEnded = _data["hearingEnded"];
            this.expectedForceStart = _data["expectedForceStart"];
            this.signupPeriode = _data["signupPeriode"];
            this.expectedIntoForceAlternateDisplayDate = _data["expectedIntoForceAlternateDisplayDate"];
            this.expectedIntoForceStartDateUtc = _data["expectedIntoForceStartDateUtc"];
            this.displayNumbers = _data["displayNumbers"];
            this.phase = _data["phase"];
            this.overallStatusName = _data["overallStatusName"];
            this.latestStatusUpdateUtc = _data["latestStatusUpdateUtc"] ? new Date(_data["latestStatusUpdateUtc"].toString()) : <any>undefined;
            this.group = _data["group"];
            this.mainAgreementName = _data["mainAgreementName"];
            this.mainAgreementId = _data["mainAgreementId"];
            this.isConsortiumAgreement = _data["isConsortiumAgreement"];
            if (Array.isArray(_data["sourcingPrograms"])) {
                this.sourcingPrograms = [] as any;
                for (let item of _data["sourcingPrograms"])
                    this.sourcingPrograms!.push(SourcingprogramListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["customerApplication"])) {
                this.customerApplication = [] as any;
                for (let item of _data["customerApplication"])
                    this.customerApplication!.push(CustomerApplicationListViewDto.fromJS(item));
            }
            this.intoForceDate = _data["intoForceDate"] ? new Date(_data["intoForceDate"].toString()) : <any>undefined;
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["contactPerson"])) {
                this.contactPerson = [] as any;
                for (let item of _data["contactPerson"])
                    this.contactPerson!.push(ContactPersonOrganizationListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["supplierReporteportingCodes"])) {
                this.supplierReporteportingCodes = [] as any;
                for (let item of _data["supplierReporteportingCodes"])
                    this.supplierReporteportingCodes!.push(item);
            }
            if (Array.isArray(_data["supplierReports"])) {
                this.supplierReports = [] as any;
                for (let item of _data["supplierReports"])
                    this.supplierReports!.push(SupplierReportDto.fromJS(item));
            }
            this.terminationDate = _data["terminationDate"] ? new Date(_data["terminationDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.nameWithYear = _data["nameWithYear"];
            this.frameworkAgreementAreaNumber = _data["frameworkAgreementAreaNumber"];
            this.frameworkAgreementNumber = _data["frameworkAgreementNumber"];
            this.partialAgreementNumber = _data["partialAgreementNumber"];
            this.frameworkAgreementYear = _data["frameworkAgreementYear"];
            this.combinedAgreementNumber = _data["combinedAgreementNumber"];
            this.agreementId = _data["agreementId"];
            this.expirationIncOptionsDate = _data["expirationIncOptionsDate"] ? new Date(_data["expirationIncOptionsDate"].toString()) : <any>undefined;
            this.showDisButton = _data["showDisButton"];
            this.disButtonUrl = _data["disButtonUrl"];
            this.disButtonText = _data["disButtonText"];
        }
    }

    static fromJS(data: any): AgreementForOrganizationListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementForOrganizationListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["url"] = this.url;
        data["displayNameLong"] = this.displayNameLong;
        data["displayNameShort"] = this.displayNameShort;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["expirationDateMaxUtc"] = this.expirationDateMaxUtc;
        data["hearingStarted"] = this.hearingStarted;
        data["hearingEnded"] = this.hearingEnded;
        data["expectedForceStart"] = this.expectedForceStart;
        data["signupPeriode"] = this.signupPeriode;
        data["expectedIntoForceAlternateDisplayDate"] = this.expectedIntoForceAlternateDisplayDate;
        data["expectedIntoForceStartDateUtc"] = this.expectedIntoForceStartDateUtc;
        data["displayNumbers"] = this.displayNumbers;
        data["phase"] = this.phase;
        data["overallStatusName"] = this.overallStatusName;
        data["latestStatusUpdateUtc"] = this.latestStatusUpdateUtc ? this.latestStatusUpdateUtc.toISOString() : <any>undefined;
        data["group"] = this.group;
        data["mainAgreementName"] = this.mainAgreementName;
        data["mainAgreementId"] = this.mainAgreementId;
        data["isConsortiumAgreement"] = this.isConsortiumAgreement;
        if (Array.isArray(this.sourcingPrograms)) {
            data["sourcingPrograms"] = [];
            for (let item of this.sourcingPrograms)
                data["sourcingPrograms"].push(item.toJSON());
        }
        if (Array.isArray(this.customerApplication)) {
            data["customerApplication"] = [];
            for (let item of this.customerApplication)
                data["customerApplication"].push(item.toJSON());
        }
        data["intoForceDate"] = this.intoForceDate ? this.intoForceDate.toISOString() : <any>undefined;
        data["expirationDate"] = this.expirationDate ? this.expirationDate.toISOString() : <any>undefined;
        if (Array.isArray(this.contactPerson)) {
            data["contactPerson"] = [];
            for (let item of this.contactPerson)
                data["contactPerson"].push(item.toJSON());
        }
        if (Array.isArray(this.supplierReporteportingCodes)) {
            data["supplierReporteportingCodes"] = [];
            for (let item of this.supplierReporteportingCodes)
                data["supplierReporteportingCodes"].push(item);
        }
        if (Array.isArray(this.supplierReports)) {
            data["supplierReports"] = [];
            for (let item of this.supplierReports)
                data["supplierReports"].push(item.toJSON());
        }
        data["terminationDate"] = this.terminationDate ? this.terminationDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["nameWithYear"] = this.nameWithYear;
        data["frameworkAgreementAreaNumber"] = this.frameworkAgreementAreaNumber;
        data["frameworkAgreementNumber"] = this.frameworkAgreementNumber;
        data["partialAgreementNumber"] = this.partialAgreementNumber;
        data["frameworkAgreementYear"] = this.frameworkAgreementYear;
        data["combinedAgreementNumber"] = this.combinedAgreementNumber;
        data["agreementId"] = this.agreementId;
        data["expirationIncOptionsDate"] = this.expirationIncOptionsDate ? formatDate(this.expirationIncOptionsDate) : <any>undefined;
        data["showDisButton"] = this.showDisButton;
        data["disButtonUrl"] = this.disButtonUrl;
        data["disButtonText"] = this.disButtonText;
        return data;
    }
}

export interface IAgreementForOrganizationListViewDto {
    id?: string;
    url?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    intoForceDateUtc?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    hearingStarted?: string;
    hearingEnded?: string;
    expectedForceStart?: string;
    signupPeriode?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    displayNumbers?: string;
    phase?: string;
    overallStatusName?: string;
    latestStatusUpdateUtc?: Date | undefined;
    group?: string;
    mainAgreementName?: string;
    mainAgreementId?: string;
    isConsortiumAgreement?: boolean;
    sourcingPrograms?: SourcingprogramListViewDto[];
    customerApplication?: CustomerApplicationListViewDto[];
    intoForceDate?: Date | undefined;
    expirationDate?: Date | undefined;
    contactPerson?: ContactPersonOrganizationListViewDto[];
    supplierReporteportingCodes?: number[];
    supplierReports?: SupplierReportDto[];
    terminationDate?: Date | undefined;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;
}

export class AgreementListStatusUpdateDto implements IAgreementListStatusUpdateDto {
    agreementId?: string;
    name?: string;
    displayNameShort?: string;
    displayNumbers?: string;
    expirationDateUtc?: string;
    overallStatusName?: string;
    agreementURL?: string;

    [key: string]: any;

    constructor(data?: IAgreementListStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.name = _data["name"];
            this.displayNameShort = _data["displayNameShort"];
            this.displayNumbers = _data["displayNumbers"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.overallStatusName = _data["overallStatusName"];
            this.agreementURL = _data["agreementURL"];
        }
    }

    static fromJS(data: any): AgreementListStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementListStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["name"] = this.name;
        data["displayNameShort"] = this.displayNameShort;
        data["displayNumbers"] = this.displayNumbers;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["overallStatusName"] = this.overallStatusName;
        data["agreementURL"] = this.agreementURL;
        return data;
    }
}

export interface IAgreementListStatusUpdateDto {
    agreementId?: string;
    name?: string;
    displayNameShort?: string;
    displayNumbers?: string;
    expirationDateUtc?: string;
    overallStatusName?: string;
    agreementURL?: string;

    [key: string]: any;
}

export class AgreementListViewDto implements IAgreementListViewDto {
    agreementId?: string;
    agreementGuid?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    phase?: string;
    tenderProcess?: string;
    group?: string;
    name?: string;
    displayNumbers?: string;
    intoForceDateUtc?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    overallStatusName?: string;
    latestStatusUpdateUtc?: string;
    alternateDisplayDate?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    catalogue?: boolean;
    greenCatalogue?: boolean;
    eCatalogOnAgreement?: boolean | undefined;
    skiNextMilestone?: NextMilestoneListViewDto;
    sourcingPrograms?: SourcingprogramListViewDto[];
    subagreement?: SubagreementListViewDto[];
    url?: string;
    customerApplication?: CustomerApplicationListViewDto;
    calendars?: CalendarDbDto[];

    [key: string]: any;

    constructor(data?: IAgreementListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.agreementGuid = _data["agreementGuid"];
            this.displayNameLong = _data["displayNameLong"];
            this.displayNameShort = _data["displayNameShort"];
            this.phase = _data["phase"];
            this.tenderProcess = _data["tenderProcess"];
            this.group = _data["group"];
            this.name = _data["name"];
            this.displayNumbers = _data["displayNumbers"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.expirationDateMaxUtc = _data["expirationDateMaxUtc"];
            this.overallStatusName = _data["overallStatusName"];
            this.latestStatusUpdateUtc = _data["latestStatusUpdateUtc"];
            this.alternateDisplayDate = _data["alternateDisplayDate"];
            this.expectedIntoForceAlternateDisplayDate = _data["expectedIntoForceAlternateDisplayDate"];
            this.expectedIntoForceStartDateUtc = _data["expectedIntoForceStartDateUtc"];
            this.catalogue = _data["catalogue"];
            this.greenCatalogue = _data["greenCatalogue"];
            this.eCatalogOnAgreement = _data["eCatalogOnAgreement"];
            this.skiNextMilestone = _data["skiNextMilestone"] ? NextMilestoneListViewDto.fromJS(_data["skiNextMilestone"]) : <any>undefined;
            if (Array.isArray(_data["sourcingPrograms"])) {
                this.sourcingPrograms = [] as any;
                for (let item of _data["sourcingPrograms"])
                    this.sourcingPrograms!.push(SourcingprogramListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["subagreement"])) {
                this.subagreement = [] as any;
                for (let item of _data["subagreement"])
                    this.subagreement!.push(SubagreementListViewDto.fromJS(item));
            }
            this.url = _data["url"];
            this.customerApplication = _data["customerApplication"] ? CustomerApplicationListViewDto.fromJS(_data["customerApplication"]) : <any>undefined;
            if (Array.isArray(_data["calendars"])) {
                this.calendars = [] as any;
                for (let item of _data["calendars"])
                    this.calendars!.push(CalendarDbDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["agreementGuid"] = this.agreementGuid;
        data["displayNameLong"] = this.displayNameLong;
        data["displayNameShort"] = this.displayNameShort;
        data["phase"] = this.phase;
        data["tenderProcess"] = this.tenderProcess;
        data["group"] = this.group;
        data["name"] = this.name;
        data["displayNumbers"] = this.displayNumbers;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["expirationDateMaxUtc"] = this.expirationDateMaxUtc;
        data["overallStatusName"] = this.overallStatusName;
        data["latestStatusUpdateUtc"] = this.latestStatusUpdateUtc;
        data["alternateDisplayDate"] = this.alternateDisplayDate;
        data["expectedIntoForceAlternateDisplayDate"] = this.expectedIntoForceAlternateDisplayDate;
        data["expectedIntoForceStartDateUtc"] = this.expectedIntoForceStartDateUtc;
        data["catalogue"] = this.catalogue;
        data["greenCatalogue"] = this.greenCatalogue;
        data["eCatalogOnAgreement"] = this.eCatalogOnAgreement;
        data["skiNextMilestone"] = this.skiNextMilestone ? this.skiNextMilestone.toJSON() : <any>undefined;
        if (Array.isArray(this.sourcingPrograms)) {
            data["sourcingPrograms"] = [];
            for (let item of this.sourcingPrograms)
                data["sourcingPrograms"].push(item.toJSON());
        }
        if (Array.isArray(this.subagreement)) {
            data["subagreement"] = [];
            for (let item of this.subagreement)
                data["subagreement"].push(item.toJSON());
        }
        data["url"] = this.url;
        data["customerApplication"] = this.customerApplication ? this.customerApplication.toJSON() : <any>undefined;
        if (Array.isArray(this.calendars)) {
            data["calendars"] = [];
            for (let item of this.calendars)
                data["calendars"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgreementListViewDto {
    agreementId?: string;
    agreementGuid?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    phase?: string;
    tenderProcess?: string;
    group?: string;
    name?: string;
    displayNumbers?: string;
    intoForceDateUtc?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    overallStatusName?: string;
    latestStatusUpdateUtc?: string;
    alternateDisplayDate?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    catalogue?: boolean;
    greenCatalogue?: boolean;
    eCatalogOnAgreement?: boolean | undefined;
    skiNextMilestone?: NextMilestoneListViewDto;
    sourcingPrograms?: SourcingprogramListViewDto[];
    subagreement?: SubagreementListViewDto[];
    url?: string;
    customerApplication?: CustomerApplicationListViewDto;
    calendars?: CalendarDbDto[];

    [key: string]: any;
}

export class AgreementListViewDtoWrapper implements IAgreementListViewDtoWrapper {
    skiAgreementlist?: AgreementListViewDto[];
    skiGroups?: GroupListViewDto[];
    skiSourcingprograms?: SourcingprogramListViewDto[];
    skiOverallStatuses?: SkiOverallstatusListViewDto[];

    [key: string]: any;

    constructor(data?: IAgreementListViewDtoWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["skiAgreementlist"])) {
                this.skiAgreementlist = [] as any;
                for (let item of _data["skiAgreementlist"])
                    this.skiAgreementlist!.push(AgreementListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["skiGroups"])) {
                this.skiGroups = [] as any;
                for (let item of _data["skiGroups"])
                    this.skiGroups!.push(GroupListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["skiSourcingprograms"])) {
                this.skiSourcingprograms = [] as any;
                for (let item of _data["skiSourcingprograms"])
                    this.skiSourcingprograms!.push(SourcingprogramListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["skiOverallStatuses"])) {
                this.skiOverallStatuses = [] as any;
                for (let item of _data["skiOverallStatuses"])
                    this.skiOverallStatuses!.push(SkiOverallstatusListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementListViewDtoWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementListViewDtoWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.skiAgreementlist)) {
            data["skiAgreementlist"] = [];
            for (let item of this.skiAgreementlist)
                data["skiAgreementlist"].push(item.toJSON());
        }
        if (Array.isArray(this.skiGroups)) {
            data["skiGroups"] = [];
            for (let item of this.skiGroups)
                data["skiGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.skiSourcingprograms)) {
            data["skiSourcingprograms"] = [];
            for (let item of this.skiSourcingprograms)
                data["skiSourcingprograms"].push(item.toJSON());
        }
        if (Array.isArray(this.skiOverallStatuses)) {
            data["skiOverallStatuses"] = [];
            for (let item of this.skiOverallStatuses)
                data["skiOverallStatuses"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgreementListViewDtoWrapper {
    skiAgreementlist?: AgreementListViewDto[];
    skiGroups?: GroupListViewDto[];
    skiSourcingprograms?: SourcingprogramListViewDto[];
    skiOverallStatuses?: SkiOverallstatusListViewDto[];

    [key: string]: any;
}

export class AgreementReference implements IAgreementReference {
    agreementId!: string;

    [key: string]: any;

    constructor(data?: IAgreementReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
        }
    }

    static fromJS(data: any): AgreementReference {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        return data;
    }
}

export interface IAgreementReference {
    agreementId: string;

    [key: string]: any;
}

export class AgreementReplacesListViewDto implements IAgreementReplacesListViewDto {
    name?: string;
    url?: string;
    id?: string;

    [key: string]: any;

    constructor(data?: IAgreementReplacesListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.url = _data["url"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): AgreementReplacesListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementReplacesListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["url"] = this.url;
        data["id"] = this.id;
        return data;
    }
}

export interface IAgreementReplacesListViewDto {
    name?: string;
    url?: string;
    id?: string;

    [key: string]: any;
}

export class AgreementSearchDto implements IAgreementSearchDto {
    agreementId?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    name?: string;
    displayNumbers?: string;
    phase?: string;
    overallStatusName?: string;
    keywords?: string;
    teaser?: string;
    group?: string;
    sourcingPrograms?: string;
    intoForceDateUtc?: string;
    expiryDateUtc?: string;
    mainAgreementId?: string;

    [key: string]: any;

    constructor(data?: IAgreementSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.displayNameLong = _data["displayNameLong"];
            this.displayNameShort = _data["displayNameShort"];
            this.name = _data["name"];
            this.displayNumbers = _data["displayNumbers"];
            this.phase = _data["phase"];
            this.overallStatusName = _data["overallStatusName"];
            this.keywords = _data["keywords"];
            this.teaser = _data["teaser"];
            this.group = _data["group"];
            this.sourcingPrograms = _data["sourcingPrograms"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.expiryDateUtc = _data["expiryDateUtc"];
            this.mainAgreementId = _data["mainAgreementId"];
        }
    }

    static fromJS(data: any): AgreementSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["displayNameLong"] = this.displayNameLong;
        data["displayNameShort"] = this.displayNameShort;
        data["name"] = this.name;
        data["displayNumbers"] = this.displayNumbers;
        data["phase"] = this.phase;
        data["overallStatusName"] = this.overallStatusName;
        data["keywords"] = this.keywords;
        data["teaser"] = this.teaser;
        data["group"] = this.group;
        data["sourcingPrograms"] = this.sourcingPrograms;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["expiryDateUtc"] = this.expiryDateUtc;
        data["mainAgreementId"] = this.mainAgreementId;
        return data;
    }
}

export interface IAgreementSearchDto {
    agreementId?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    name?: string;
    displayNumbers?: string;
    phase?: string;
    overallStatusName?: string;
    keywords?: string;
    teaser?: string;
    group?: string;
    sourcingPrograms?: string;
    intoForceDateUtc?: string;
    expiryDateUtc?: string;
    mainAgreementId?: string;

    [key: string]: any;
}

export class AgreementStatusUpdateDto implements IAgreementStatusUpdateDto {
    statusUpdate?: SkiStatusupdate;
    id?: string;
    dateUtc?: string;
    title?: string;
    url?: string;
    category?: string;

    [key: string]: any;

    constructor(data?: IAgreementStatusUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.statusUpdate = _data["statusUpdate"] ? SkiStatusupdate.fromJS(_data["statusUpdate"]) : <any>undefined;
            this.id = _data["id"];
            this.dateUtc = _data["dateUtc"];
            this.title = _data["title"];
            this.url = _data["url"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): AgreementStatusUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementStatusUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["statusUpdate"] = this.statusUpdate ? this.statusUpdate.toJSON() : <any>undefined;
        data["id"] = this.id;
        data["dateUtc"] = this.dateUtc;
        data["title"] = this.title;
        data["url"] = this.url;
        data["category"] = this.category;
        return data;
    }
}

export interface IAgreementStatusUpdateDto {
    statusUpdate?: SkiStatusupdate;
    id?: string;
    dateUtc?: string;
    title?: string;
    url?: string;
    category?: string;

    [key: string]: any;
}

export class AgreementsWithSuppliersResponse implements IAgreementsWithSuppliersResponse {
    agreements?: Agreement[];

    [key: string]: any;

    constructor(data?: IAgreementsWithSuppliersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(Agreement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AgreementsWithSuppliersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AgreementsWithSuppliersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAgreementsWithSuppliersResponse {
    agreements?: Agreement[];

    [key: string]: any;
}

export class CalendarDbDto implements ICalendarDbDto {
    skiCalendarId?: string | undefined;
    skiAgreement?: string | undefined;
    skiStartdate?: Date | undefined;
    skiName?: string;
    skiAlternativeenddate?: string;
    skiCalendartheme?: string | undefined;
    includeInExcel?: boolean | undefined;

    [key: string]: any;

    constructor(data?: ICalendarDbDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.skiCalendarId = _data["skiCalendarId"];
            this.skiAgreement = _data["skiAgreement"];
            this.skiStartdate = _data["skiStartdate"] ? new Date(_data["skiStartdate"].toString()) : <any>undefined;
            this.skiName = _data["skiName"];
            this.skiAlternativeenddate = _data["skiAlternativeenddate"];
            this.skiCalendartheme = _data["skiCalendartheme"];
            this.includeInExcel = _data["includeInExcel"];
        }
    }

    static fromJS(data: any): CalendarDbDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDbDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["skiCalendarId"] = this.skiCalendarId;
        data["skiAgreement"] = this.skiAgreement;
        data["skiStartdate"] = this.skiStartdate ? this.skiStartdate.toISOString() : <any>undefined;
        data["skiName"] = this.skiName;
        data["skiAlternativeenddate"] = this.skiAlternativeenddate;
        data["skiCalendartheme"] = this.skiCalendartheme;
        data["includeInExcel"] = this.includeInExcel;
        return data;
    }
}

export interface ICalendarDbDto {
    skiCalendarId?: string | undefined;
    skiAgreement?: string | undefined;
    skiStartdate?: Date | undefined;
    skiName?: string;
    skiAlternativeenddate?: string;
    skiCalendartheme?: string | undefined;
    includeInExcel?: boolean | undefined;

    [key: string]: any;
}

export class CalendarListItemDto implements ICalendarListItemDto {
    subject?: string;
    startDateUtc?: string;
    alternateDisplayDate?: string;
    teaser?: string;

    [key: string]: any;

    constructor(data?: ICalendarListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.subject = _data["subject"];
            this.startDateUtc = _data["startDateUtc"];
            this.alternateDisplayDate = _data["alternateDisplayDate"];
            this.teaser = _data["teaser"];
        }
    }

    static fromJS(data: any): CalendarListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["subject"] = this.subject;
        data["startDateUtc"] = this.startDateUtc;
        data["alternateDisplayDate"] = this.alternateDisplayDate;
        data["teaser"] = this.teaser;
        return data;
    }
}

export interface ICalendarListItemDto {
    subject?: string;
    startDateUtc?: string;
    alternateDisplayDate?: string;
    teaser?: string;

    [key: string]: any;
}

export class ContactListViewDto implements IContactListViewDto {
    fullContactName?: string;
    occupation?: string;
    email?: string;
    phone?: string;
    linkToImage?: string;

    [key: string]: any;

    constructor(data?: IContactListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.fullContactName = _data["fullContactName"];
            this.occupation = _data["occupation"];
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.linkToImage = _data["linkToImage"];
        }
    }

    static fromJS(data: any): ContactListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["fullContactName"] = this.fullContactName;
        data["occupation"] = this.occupation;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["linkToImage"] = this.linkToImage;
        return data;
    }
}

export interface IContactListViewDto {
    fullContactName?: string;
    occupation?: string;
    email?: string;
    phone?: string;
    linkToImage?: string;

    [key: string]: any;
}

export class ContactPerson implements IContactPerson {
    contactId?: string;
    email?: string;
    firstname?: string;
    surname?: string;
    title?: string;
    telephone?: string;
    orgId?: string;

    [key: string]: any;

    constructor(data?: IContactPerson) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.contactId = _data["contactId"];
            this.email = _data["email"];
            this.firstname = _data["firstname"];
            this.surname = _data["surname"];
            this.title = _data["title"];
            this.telephone = _data["telephone"];
            this.orgId = _data["orgId"];
        }
    }

    static fromJS(data: any): ContactPerson {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPerson();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["contactId"] = this.contactId;
        data["email"] = this.email;
        data["firstname"] = this.firstname;
        data["surname"] = this.surname;
        data["title"] = this.title;
        data["telephone"] = this.telephone;
        data["orgId"] = this.orgId;
        return data;
    }
}

export interface IContactPerson {
    contactId?: string;
    email?: string;
    firstname?: string;
    surname?: string;
    title?: string;
    telephone?: string;
    orgId?: string;

    [key: string]: any;
}

export class ContactPersonOrganizationListViewDto implements IContactPersonOrganizationListViewDto {
    role?: string;
    fullname?: string;
    phone?: string;
    email?: string;
    jobTitle?: string;
    agreement?: string | undefined;

    [key: string]: any;

    constructor(data?: IContactPersonOrganizationListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            this.fullname = _data["fullname"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
            this.agreement = _data["agreement"];
        }
    }

    static fromJS(data: any): ContactPersonOrganizationListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ContactPersonOrganizationListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        data["fullname"] = this.fullname;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        data["agreement"] = this.agreement;
        return data;
    }
}

export interface IContactPersonOrganizationListViewDto {
    role?: string;
    fullname?: string;
    phone?: string;
    email?: string;
    jobTitle?: string;
    agreement?: string | undefined;

    [key: string]: any;
}

export class CrmSkiExtensionListViewDto implements ICrmSkiExtensionListViewDto {
    optionNumber?: number | undefined;
    optionIntoForceDateUtc?: string;
    optionLength?: number | undefined;

    [key: string]: any;

    constructor(data?: ICrmSkiExtensionListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.optionNumber = _data["optionNumber"];
            this.optionIntoForceDateUtc = _data["optionIntoForceDateUtc"];
            this.optionLength = _data["optionLength"];
        }
    }

    static fromJS(data: any): CrmSkiExtensionListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CrmSkiExtensionListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["optionNumber"] = this.optionNumber;
        data["optionIntoForceDateUtc"] = this.optionIntoForceDateUtc;
        data["optionLength"] = this.optionLength;
        return data;
    }
}

export interface ICrmSkiExtensionListViewDto {
    optionNumber?: number | undefined;
    optionIntoForceDateUtc?: string;
    optionLength?: number | undefined;

    [key: string]: any;
}

export class CustomerApplicationListViewDto implements ICustomerApplicationListViewDto {
    organizationId?: string;
    connectiontext?: string;
    startdateUtc?: string;
    enddateUtc?: string;
    applicationType?: string;
    applicationLabel?: string;
    applicationDescription?: string;
    endOfLateSignUpPeriod?: Date | undefined;

    [key: string]: any;

    constructor(data?: ICustomerApplicationListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
            this.connectiontext = _data["connectiontext"];
            this.startdateUtc = _data["startdateUtc"];
            this.enddateUtc = _data["enddateUtc"];
            this.applicationType = _data["applicationType"];
            this.applicationLabel = _data["applicationLabel"];
            this.applicationDescription = _data["applicationDescription"];
            this.endOfLateSignUpPeriod = _data["endOfLateSignUpPeriod"] ? new Date(_data["endOfLateSignUpPeriod"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CustomerApplicationListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerApplicationListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        data["connectiontext"] = this.connectiontext;
        data["startdateUtc"] = this.startdateUtc;
        data["enddateUtc"] = this.enddateUtc;
        data["applicationType"] = this.applicationType;
        data["applicationLabel"] = this.applicationLabel;
        data["applicationDescription"] = this.applicationDescription;
        data["endOfLateSignUpPeriod"] = this.endOfLateSignUpPeriod ? this.endOfLateSignUpPeriod.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICustomerApplicationListViewDto {
    organizationId?: string;
    connectiontext?: string;
    startdateUtc?: string;
    enddateUtc?: string;
    applicationType?: string;
    applicationLabel?: string;
    applicationDescription?: string;
    endOfLateSignUpPeriod?: Date | undefined;

    [key: string]: any;
}

export class CustomerListApplicationViewDto implements ICustomerListApplicationViewDto {
    applicationType?: string;
    customerList?: MinifiedCustomerListViewDto[];

    [key: string]: any;

    constructor(data?: ICustomerListApplicationViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.applicationType = _data["applicationType"];
            if (Array.isArray(_data["customerList"])) {
                this.customerList = [] as any;
                for (let item of _data["customerList"])
                    this.customerList!.push(MinifiedCustomerListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerListApplicationViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListApplicationViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["applicationType"] = this.applicationType;
        if (Array.isArray(this.customerList)) {
            data["customerList"] = [];
            for (let item of this.customerList)
                data["customerList"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerListApplicationViewDto {
    applicationType?: string;
    customerList?: MinifiedCustomerListViewDto[];

    [key: string]: any;
}

export class CustomerListDtoWrapper implements ICustomerListDtoWrapper {
    agreementid?: string;
    customerListApplications?: CustomerListApplicationViewDto[];

    [key: string]: any;

    constructor(data?: ICustomerListDtoWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementid = _data["agreementid"];
            if (Array.isArray(_data["customerListApplications"])) {
                this.customerListApplications = [] as any;
                for (let item of _data["customerListApplications"])
                    this.customerListApplications!.push(CustomerListApplicationViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CustomerListDtoWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerListDtoWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementid"] = this.agreementid;
        if (Array.isArray(this.customerListApplications)) {
            data["customerListApplications"] = [];
            for (let item of this.customerListApplications)
                data["customerListApplications"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerListDtoWrapper {
    agreementid?: string;
    customerListApplications?: CustomerListApplicationViewDto[];

    [key: string]: any;
}

export class DescriptionListViewDto implements IDescriptionListViewDto {
    agreementDescriptionName?: string;
    orderByNumber?: number | undefined;
    agreementDescriptionText?: string;

    [key: string]: any;

    constructor(data?: IDescriptionListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementDescriptionName = _data["agreementDescriptionName"];
            this.orderByNumber = _data["orderByNumber"];
            this.agreementDescriptionText = _data["agreementDescriptionText"];
        }
    }

    static fromJS(data: any): DescriptionListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new DescriptionListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementDescriptionName"] = this.agreementDescriptionName;
        data["orderByNumber"] = this.orderByNumber;
        data["agreementDescriptionText"] = this.agreementDescriptionText;
        return data;
    }
}

export interface IDescriptionListViewDto {
    agreementDescriptionName?: string;
    orderByNumber?: number | undefined;
    agreementDescriptionText?: string;

    [key: string]: any;
}

export class DispensationDto implements IDispensationDto {
    id!: string;
    agreement!: AgreementReference;
    organization!: OrganizationReference;
    from?: Date | undefined;
    to?: Date | undefined;
    modifiedOn!: Date;
    modifiedBy!: string;
    classes!: Classes[];
    isActive!: boolean;

    [key: string]: any;

    constructor(data?: IDispensationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.agreement = new AgreementReference();
            this.organization = new OrganizationReference();
            this.classes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.agreement = _data["agreement"] ? AgreementReference.fromJS(_data["agreement"]) : new AgreementReference();
            this.organization = _data["organization"] ? OrganizationReference.fromJS(_data["organization"]) : new OrganizationReference();
            this.from = _data["from"] ? new Date(_data["from"].toString()) : <any>undefined;
            this.to = _data["to"] ? new Date(_data["to"].toString()) : <any>undefined;
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            if (Array.isArray(_data["classes"])) {
                this.classes = [] as any;
                for (let item of _data["classes"])
                    this.classes!.push(item);
            }
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): DispensationDto {
        data = typeof data === 'object' ? data : {};
        let result = new DispensationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        data["from"] = this.from ? this.from.toISOString() : <any>undefined;
        data["to"] = this.to ? this.to.toISOString() : <any>undefined;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        if (Array.isArray(this.classes)) {
            data["classes"] = [];
            for (let item of this.classes)
                data["classes"].push(item);
        }
        data["isActive"] = this.isActive;
        return data;
    }
}

export interface IDispensationDto {
    id: string;
    agreement: AgreementReference;
    organization: OrganizationReference;
    from?: Date | undefined;
    to?: Date | undefined;
    modifiedOn: Date;
    modifiedBy: string;
    classes: Classes[];
    isActive: boolean;

    [key: string]: any;
}

export class DocumentAuthorization implements IDocumentAuthorization {
    authorized!: boolean;
    unauthorizedReason?: DocumentAuthorizationUnauthorizedReason | undefined;
    missingRoles!: string[];

    [key: string]: any;

    constructor(data?: IDocumentAuthorization) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.unauthorizedReason = DocumentAuthorizationUnauthorizedReason._0;
            this.missingRoles = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.authorized = _data["authorized"];
            this.unauthorizedReason = _data["unauthorizedReason"] !== undefined ? _data["unauthorizedReason"] : DocumentAuthorizationUnauthorizedReason._0;
            if (Array.isArray(_data["missingRoles"])) {
                this.missingRoles = [] as any;
                for (let item of _data["missingRoles"])
                    this.missingRoles!.push(item);
            }
        }
    }

    static fromJS(data: any): DocumentAuthorization {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentAuthorization();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["authorized"] = this.authorized;
        data["unauthorizedReason"] = this.unauthorizedReason;
        if (Array.isArray(this.missingRoles)) {
            data["missingRoles"] = [];
            for (let item of this.missingRoles)
                data["missingRoles"].push(item);
        }
        return data;
    }
}

export interface IDocumentAuthorization {
    authorized: boolean;
    unauthorizedReason?: DocumentAuthorizationUnauthorizedReason | undefined;
    missingRoles: string[];

    [key: string]: any;
}

export class EmployeeListViewDto implements IEmployeeListViewDto {
    id?: string;
    firstname?: string;
    lastname?: string;
    jobtitle?: string;
    mail?: string;
    telephone?: string;
    linkedIn?: string;
    ordernumber?: number | undefined;
    url?: string;
    team?: string;
    picture?: string;

    [key: string]: any;

    constructor(data?: IEmployeeListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.jobtitle = _data["jobtitle"];
            this.mail = _data["mail"];
            this.telephone = _data["telephone"];
            this.linkedIn = _data["linkedIn"];
            this.ordernumber = _data["ordernumber"];
            this.url = _data["url"];
            this.team = _data["team"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): EmployeeListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["jobtitle"] = this.jobtitle;
        data["mail"] = this.mail;
        data["telephone"] = this.telephone;
        data["linkedIn"] = this.linkedIn;
        data["ordernumber"] = this.ordernumber;
        data["url"] = this.url;
        data["team"] = this.team;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IEmployeeListViewDto {
    id?: string;
    firstname?: string;
    lastname?: string;
    jobtitle?: string;
    mail?: string;
    telephone?: string;
    linkedIn?: string;
    ordernumber?: number | undefined;
    url?: string;
    team?: string;
    picture?: string;

    [key: string]: any;
}

export class EmployeeListViewDtoWrapper implements IEmployeeListViewDtoWrapper {
    skiEmployeesList?: EmployeeListViewDto[];
    skiTeamlist?: TeamListViewDto[];

    [key: string]: any;

    constructor(data?: IEmployeeListViewDtoWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["skiEmployeesList"])) {
                this.skiEmployeesList = [] as any;
                for (let item of _data["skiEmployeesList"])
                    this.skiEmployeesList!.push(EmployeeListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["skiTeamlist"])) {
                this.skiTeamlist = [] as any;
                for (let item of _data["skiTeamlist"])
                    this.skiTeamlist!.push(TeamListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EmployeeListViewDtoWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeListViewDtoWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.skiEmployeesList)) {
            data["skiEmployeesList"] = [];
            for (let item of this.skiEmployeesList)
                data["skiEmployeesList"].push(item.toJSON());
        }
        if (Array.isArray(this.skiTeamlist)) {
            data["skiTeamlist"] = [];
            for (let item of this.skiTeamlist)
                data["skiTeamlist"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEmployeeListViewDtoWrapper {
    skiEmployeesList?: EmployeeListViewDto[];
    skiTeamlist?: TeamListViewDto[];

    [key: string]: any;
}

export class EnrichedSupplierListViewDto implements IEnrichedSupplierListViewDto {
    agreementApprovals?: string[];
    supplierName?: string;
    url?: string;
    supplyRoles?: SupplyRoleListViewDto[];
    organizationId?: string;
    cvrNummer?: string;

    [key: string]: any;

    constructor(data?: IEnrichedSupplierListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["agreementApprovals"])) {
                this.agreementApprovals = [] as any;
                for (let item of _data["agreementApprovals"])
                    this.agreementApprovals!.push(item);
            }
            this.supplierName = _data["supplierName"];
            this.url = _data["url"];
            if (Array.isArray(_data["supplyRoles"])) {
                this.supplyRoles = [] as any;
                for (let item of _data["supplyRoles"])
                    this.supplyRoles!.push(SupplyRoleListViewDto.fromJS(item));
            }
            this.organizationId = _data["organizationId"];
            this.cvrNummer = _data["cvrNummer"];
        }
    }

    static fromJS(data: any): EnrichedSupplierListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new EnrichedSupplierListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.agreementApprovals)) {
            data["agreementApprovals"] = [];
            for (let item of this.agreementApprovals)
                data["agreementApprovals"].push(item);
        }
        data["supplierName"] = this.supplierName;
        data["url"] = this.url;
        if (Array.isArray(this.supplyRoles)) {
            data["supplyRoles"] = [];
            for (let item of this.supplyRoles)
                data["supplyRoles"].push(item.toJSON());
        }
        data["organizationId"] = this.organizationId;
        data["cvrNummer"] = this.cvrNummer;
        return data;
    }
}

export interface IEnrichedSupplierListViewDto {
    agreementApprovals?: string[];
    supplierName?: string;
    url?: string;
    supplyRoles?: SupplyRoleListViewDto[];
    organizationId?: string;
    cvrNummer?: string;

    [key: string]: any;
}

export class EOrderDto implements IEOrderDto {
    endpointId?: string;
    profile?: string;

    [key: string]: any;

    constructor(data?: IEOrderDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.endpointId = _data["endpointId"];
            this.profile = _data["profile"];
        }
    }

    static fromJS(data: any): EOrderDto {
        data = typeof data === 'object' ? data : {};
        let result = new EOrderDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["endpointId"] = this.endpointId;
        data["profile"] = this.profile;
        return data;
    }
}

export interface IEOrderDto {
    endpointId?: string;
    profile?: string;

    [key: string]: any;
}

export class Exception implements IException {

    [key: string]: any;

    constructor(data?: IException) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): Exception {
        data = typeof data === 'object' ? data : {};
        let result = new Exception();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IException {

    [key: string]: any;
}

export class FaqListViewDto implements IFaqListViewDto {
    agreementId?: string;
    name?: string;
    question?: string;
    answer?: string;

    [key: string]: any;

    constructor(data?: IFaqListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.name = _data["name"];
            this.question = _data["question"];
            this.answer = _data["answer"];
        }
    }

    static fromJS(data: any): FaqListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new FaqListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["name"] = this.name;
        data["question"] = this.question;
        data["answer"] = this.answer;
        return data;
    }
}

export interface IFaqListViewDto {
    agreementId?: string;
    name?: string;
    question?: string;
    answer?: string;

    [key: string]: any;
}

export class GetContactsForOrganizationResponse implements IGetContactsForOrganizationResponse {
    contacts!: ContactPerson[];

    [key: string]: any;

    constructor(data?: IGetContactsForOrganizationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.contacts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ContactPerson.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetContactsForOrganizationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetContactsForOrganizationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetContactsForOrganizationResponse {
    contacts: ContactPerson[];

    [key: string]: any;
}

export class GetDispensationResponse implements IGetDispensationResponse {
    dispensations!: DispensationDto[];

    [key: string]: any;

    constructor(data?: IGetDispensationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.dispensations = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["dispensations"])) {
                this.dispensations = [] as any;
                for (let item of _data["dispensations"])
                    this.dispensations!.push(DispensationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetDispensationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetDispensationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.dispensations)) {
            data["dispensations"] = [];
            for (let item of this.dispensations)
                data["dispensations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetDispensationResponse {
    dispensations: DispensationDto[];

    [key: string]: any;
}

export class GetInvoiceEligibleOrgResponse implements IGetInvoiceEligibleOrgResponse {
    organizations?: NavisionOrganizationDto[];

    [key: string]: any;

    constructor(data?: IGetInvoiceEligibleOrgResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["organizations"])) {
                this.organizations = [] as any;
                for (let item of _data["organizations"])
                    this.organizations!.push(NavisionOrganizationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetInvoiceEligibleOrgResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetInvoiceEligibleOrgResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.organizations)) {
            data["organizations"] = [];
            for (let item of this.organizations)
                data["organizations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetInvoiceEligibleOrgResponse {
    organizations?: NavisionOrganizationDto[];

    [key: string]: any;
}

export class GreenFilterDto implements IGreenFilterDto {
    filterId?: string;
    filterValues?: string[];

    [key: string]: any;

    constructor(data?: IGreenFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.filterId = _data["filterId"];
            if (Array.isArray(_data["filterValues"])) {
                this.filterValues = [] as any;
                for (let item of _data["filterValues"])
                    this.filterValues!.push(item);
            }
        }
    }

    static fromJS(data: any): GreenFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new GreenFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["filterId"] = this.filterId;
        if (Array.isArray(this.filterValues)) {
            data["filterValues"] = [];
            for (let item of this.filterValues)
                data["filterValues"].push(item);
        }
        return data;
    }
}

export interface IGreenFilterDto {
    filterId?: string;
    filterValues?: string[];

    [key: string]: any;
}

export class GroupListViewDto implements IGroupListViewDto {
    name?: string;

    [key: string]: any;

    constructor(data?: IGroupListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): GroupListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IGroupListViewDto {
    name?: string;

    [key: string]: any;
}

export class HealthCheckResult implements IHealthCheckResult {
    data?: { [key: string]: any; };
    description?: string;
    exception?: any;
    status?: HealthCheckResultStatus;

    [key: string]: any;

    constructor(data?: IHealthCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = HealthCheckResultStatus._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (_data["data"]) {
                this.data = {} as any;
                for (let key in _data["data"]) {
                    if (_data["data"].hasOwnProperty(key))
                        (<any>this.data)![key] = _data["data"][key];
                }
            }
            this.description = _data["description"];
            this.exception = _data["exception"];
            this.status = _data["status"] !== undefined ? _data["status"] : HealthCheckResultStatus._0;
        }
    }

    static fromJS(data: any): HealthCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new HealthCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (this.data) {
            data["data"] = {};
            for (let key in this.data) {
                if (this.data.hasOwnProperty(key))
                    (<any>data["data"])[key] = (<any>this.data)[key];
            }
        }
        data["description"] = this.description;
        data["exception"] = this.exception;
        data["status"] = this.status;
        return data;
    }
}

export interface IHealthCheckResult {
    data?: { [key: string]: any; };
    description?: string;
    exception?: any;
    status?: HealthCheckResultStatus;

    [key: string]: any;
}

export class KeywordDto implements IKeywordDto {
    title?: string;

    [key: string]: any;

    constructor(data?: IKeywordDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): KeywordDto {
        data = typeof data === 'object' ? data : {};
        let result = new KeywordDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["title"] = this.title;
        return data;
    }
}

export interface IKeywordDto {
    title?: string;

    [key: string]: any;
}

export class MinifiedCustomerListViewDto implements IMinifiedCustomerListViewDto {
    companyname?: string;
    applicationLabel?: string;
    connectiontext?: string;
    url?: string;
    organizationId?: string;
    agreementCustomerEnddate?: Date | undefined;

    [key: string]: any;

    constructor(data?: IMinifiedCustomerListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.companyname = _data["companyname"];
            this.applicationLabel = _data["applicationLabel"];
            this.connectiontext = _data["connectiontext"];
            this.url = _data["url"];
            this.organizationId = _data["organizationId"];
            this.agreementCustomerEnddate = _data["agreementCustomerEnddate"] ? new Date(_data["agreementCustomerEnddate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): MinifiedCustomerListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MinifiedCustomerListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["companyname"] = this.companyname;
        data["applicationLabel"] = this.applicationLabel;
        data["connectiontext"] = this.connectiontext;
        data["url"] = this.url;
        data["organizationId"] = this.organizationId;
        data["agreementCustomerEnddate"] = this.agreementCustomerEnddate ? this.agreementCustomerEnddate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IMinifiedCustomerListViewDto {
    companyname?: string;
    applicationLabel?: string;
    connectiontext?: string;
    url?: string;
    organizationId?: string;
    agreementCustomerEnddate?: Date | undefined;

    [key: string]: any;
}

export class NavisionOrganizationDto implements INavisionOrganizationDto {
    orgId?: string;
    name?: string;
    department?: string;
    address?: string;
    address2?: string;
    postalCode?: string;
    city?: string;
    invoiceRecipientName?: string;
    invoiceEmail?: string;
    phoneNo?: string;
    telefaxNo?: string;
    countryCode?: string;
    eanNo?: string;
    cvr?: string;
    organizationType?: string;
    organizationAccountingGroup?: string;
    vatOrganizationAccountingGroup?: string;
    debtorOrgId?: string;
    vat?: string;

    [key: string]: any;

    constructor(data?: INavisionOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.orgId = _data["orgId"];
            this.name = _data["name"];
            this.department = _data["department"];
            this.address = _data["address"];
            this.address2 = _data["address2"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
            this.invoiceRecipientName = _data["invoiceRecipientName"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.phoneNo = _data["phoneNo"];
            this.telefaxNo = _data["telefaxNo"];
            this.countryCode = _data["countryCode"];
            this.eanNo = _data["eanNo"];
            this.cvr = _data["cvr"];
            this.organizationType = _data["organizationType"];
            this.organizationAccountingGroup = _data["organizationAccountingGroup"];
            this.vatOrganizationAccountingGroup = _data["vatOrganizationAccountingGroup"];
            this.debtorOrgId = _data["debtorOrgId"];
            this.vat = _data["vat"];
        }
    }

    static fromJS(data: any): NavisionOrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new NavisionOrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["orgId"] = this.orgId;
        data["name"] = this.name;
        data["department"] = this.department;
        data["address"] = this.address;
        data["address2"] = this.address2;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        data["invoiceRecipientName"] = this.invoiceRecipientName;
        data["invoiceEmail"] = this.invoiceEmail;
        data["phoneNo"] = this.phoneNo;
        data["telefaxNo"] = this.telefaxNo;
        data["countryCode"] = this.countryCode;
        data["eanNo"] = this.eanNo;
        data["cvr"] = this.cvr;
        data["organizationType"] = this.organizationType;
        data["organizationAccountingGroup"] = this.organizationAccountingGroup;
        data["vatOrganizationAccountingGroup"] = this.vatOrganizationAccountingGroup;
        data["debtorOrgId"] = this.debtorOrgId;
        data["vat"] = this.vat;
        return data;
    }
}

export interface INavisionOrganizationDto {
    orgId?: string;
    name?: string;
    department?: string;
    address?: string;
    address2?: string;
    postalCode?: string;
    city?: string;
    invoiceRecipientName?: string;
    invoiceEmail?: string;
    phoneNo?: string;
    telefaxNo?: string;
    countryCode?: string;
    eanNo?: string;
    cvr?: string;
    organizationType?: string;
    organizationAccountingGroup?: string;
    vatOrganizationAccountingGroup?: string;
    debtorOrgId?: string;
    vat?: string;

    [key: string]: any;
}

export class NextMilestoneListViewDto implements INextMilestoneListViewDto {
    name?: string;
    skiStartdateUtc?: string;
    skiAlternavtivenenddate?: string;

    [key: string]: any;

    constructor(data?: INextMilestoneListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.skiStartdateUtc = _data["skiStartdateUtc"];
            this.skiAlternavtivenenddate = _data["skiAlternavtivenenddate"];
        }
    }

    static fromJS(data: any): NextMilestoneListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new NextMilestoneListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["skiStartdateUtc"] = this.skiStartdateUtc;
        data["skiAlternavtivenenddate"] = this.skiAlternavtivenenddate;
        return data;
    }
}

export interface INextMilestoneListViewDto {
    name?: string;
    skiStartdateUtc?: string;
    skiAlternavtivenenddate?: string;

    [key: string]: any;
}

export class OrganizationAgreement implements IOrganizationAgreement {
    mainAgreementId?: string;
    mainAgreementDisplayNameShort?: string;
    mainAgreementIntoForceDateUtc?: Date | undefined;
    agreementId?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    supplierReports?: OrganizationSupplierReport[];
    intoForceDateUtc?: Date | undefined;

    [key: string]: any;

    constructor(data?: IOrganizationAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.mainAgreementId = _data["mainAgreementId"];
            this.mainAgreementDisplayNameShort = _data["mainAgreementDisplayNameShort"];
            this.mainAgreementIntoForceDateUtc = _data["mainAgreementIntoForceDateUtc"] ? new Date(_data["mainAgreementIntoForceDateUtc"].toString()) : <any>undefined;
            this.agreementId = _data["agreementId"];
            this.displayNameLong = _data["displayNameLong"];
            this.displayNameShort = _data["displayNameShort"];
            if (Array.isArray(_data["supplierReports"])) {
                this.supplierReports = [] as any;
                for (let item of _data["supplierReports"])
                    this.supplierReports!.push(OrganizationSupplierReport.fromJS(item));
            }
            this.intoForceDateUtc = _data["intoForceDateUtc"] ? new Date(_data["intoForceDateUtc"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["mainAgreementId"] = this.mainAgreementId;
        data["mainAgreementDisplayNameShort"] = this.mainAgreementDisplayNameShort;
        data["mainAgreementIntoForceDateUtc"] = this.mainAgreementIntoForceDateUtc ? this.mainAgreementIntoForceDateUtc.toISOString() : <any>undefined;
        data["agreementId"] = this.agreementId;
        data["displayNameLong"] = this.displayNameLong;
        data["displayNameShort"] = this.displayNameShort;
        if (Array.isArray(this.supplierReports)) {
            data["supplierReports"] = [];
            for (let item of this.supplierReports)
                data["supplierReports"].push(item.toJSON());
        }
        data["intoForceDateUtc"] = this.intoForceDateUtc ? this.intoForceDateUtc.toISOString() : <any>undefined;
        return data;
    }
}

export interface IOrganizationAgreement {
    mainAgreementId?: string;
    mainAgreementDisplayNameShort?: string;
    mainAgreementIntoForceDateUtc?: Date | undefined;
    agreementId?: string;
    displayNameLong?: string;
    displayNameShort?: string;
    supplierReports?: OrganizationSupplierReport[];
    intoForceDateUtc?: Date | undefined;

    [key: string]: any;
}

export class OrganizationAgreementList implements IOrganizationAgreementList {
    agreements?: OrganizationAgreement[];

    [key: string]: any;

    constructor(data?: IOrganizationAgreementList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(OrganizationAgreement.fromJS(item));
            }
        }
    }

    static fromJS(data: any): OrganizationAgreementList {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationAgreementList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOrganizationAgreementList {
    agreements?: OrganizationAgreement[];

    [key: string]: any;
}

export class OrganizationDto implements IOrganizationDto {
    id?: string;
    name?: string;
    href?: string;
    reportingRequirements?: ReportingRequirementsWrapper;

    [key: string]: any;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.href = _data["href"];
            this.reportingRequirements = _data["reportingRequirements"] ? ReportingRequirementsWrapper.fromJS(_data["reportingRequirements"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["href"] = this.href;
        data["reportingRequirements"] = this.reportingRequirements ? this.reportingRequirements.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationDto {
    id?: string;
    name?: string;
    href?: string;
    reportingRequirements?: ReportingRequirementsWrapper;

    [key: string]: any;
}

export class OrganizationListViewDto implements IOrganizationListViewDto {
    name?: string;
    addressName?: string;
    street?: string;
    postalcode?: string;
    city?: string;
    country?: string;
    mail?: string;
    cvr?: string;
    vat?: string;
    website?: string;
    role?: string;
    ean?: string;
    secretary?: SecretaryDto;
    groups?: GroupListViewDto[];
    agreement?: AgreementForOrganizationListViewDto[];
    supplier?: SupplierForOrganizationListViewDto[];
    subscriptionType?: string;
    subscriptionStartDate?: string;
    projectGroup?: ProjectGroupListViewDto[];
    shoppingCommunity?: ShoppingCommunityForCustomerList[];
    sourcingPrograms?: SourcingprogramListViewDto[];
    eOrderInfo?: EOrderDto;

    [key: string]: any;

    constructor(data?: IOrganizationListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.addressName = _data["addressName"];
            this.street = _data["street"];
            this.postalcode = _data["postalcode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.mail = _data["mail"];
            this.cvr = _data["cvr"];
            this.vat = _data["vat"];
            this.website = _data["website"];
            this.role = _data["role"];
            this.ean = _data["ean"];
            this.secretary = _data["secretary"] ? SecretaryDto.fromJS(_data["secretary"]) : <any>undefined;
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["agreement"])) {
                this.agreement = [] as any;
                for (let item of _data["agreement"])
                    this.agreement!.push(AgreementForOrganizationListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["supplier"])) {
                this.supplier = [] as any;
                for (let item of _data["supplier"])
                    this.supplier!.push(SupplierForOrganizationListViewDto.fromJS(item));
            }
            this.subscriptionType = _data["subscriptionType"];
            this.subscriptionStartDate = _data["subscriptionStartDate"];
            if (Array.isArray(_data["projectGroup"])) {
                this.projectGroup = [] as any;
                for (let item of _data["projectGroup"])
                    this.projectGroup!.push(ProjectGroupListViewDto.fromJS(item));
            }
            if (Array.isArray(_data["shoppingCommunity"])) {
                this.shoppingCommunity = [] as any;
                for (let item of _data["shoppingCommunity"])
                    this.shoppingCommunity!.push(ShoppingCommunityForCustomerList.fromJS(item));
            }
            if (Array.isArray(_data["sourcingPrograms"])) {
                this.sourcingPrograms = [] as any;
                for (let item of _data["sourcingPrograms"])
                    this.sourcingPrograms!.push(SourcingprogramListViewDto.fromJS(item));
            }
            this.eOrderInfo = _data["eOrderInfo"] ? EOrderDto.fromJS(_data["eOrderInfo"]) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["addressName"] = this.addressName;
        data["street"] = this.street;
        data["postalcode"] = this.postalcode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["mail"] = this.mail;
        data["cvr"] = this.cvr;
        data["vat"] = this.vat;
        data["website"] = this.website;
        data["role"] = this.role;
        data["ean"] = this.ean;
        data["secretary"] = this.secretary ? this.secretary.toJSON() : <any>undefined;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        if (Array.isArray(this.agreement)) {
            data["agreement"] = [];
            for (let item of this.agreement)
                data["agreement"].push(item.toJSON());
        }
        if (Array.isArray(this.supplier)) {
            data["supplier"] = [];
            for (let item of this.supplier)
                data["supplier"].push(item.toJSON());
        }
        data["subscriptionType"] = this.subscriptionType;
        data["subscriptionStartDate"] = this.subscriptionStartDate;
        if (Array.isArray(this.projectGroup)) {
            data["projectGroup"] = [];
            for (let item of this.projectGroup)
                data["projectGroup"].push(item.toJSON());
        }
        if (Array.isArray(this.shoppingCommunity)) {
            data["shoppingCommunity"] = [];
            for (let item of this.shoppingCommunity)
                data["shoppingCommunity"].push(item.toJSON());
        }
        if (Array.isArray(this.sourcingPrograms)) {
            data["sourcingPrograms"] = [];
            for (let item of this.sourcingPrograms)
                data["sourcingPrograms"].push(item.toJSON());
        }
        data["eOrderInfo"] = this.eOrderInfo ? this.eOrderInfo.toJSON() : <any>undefined;
        return data;
    }
}

export interface IOrganizationListViewDto {
    name?: string;
    addressName?: string;
    street?: string;
    postalcode?: string;
    city?: string;
    country?: string;
    mail?: string;
    cvr?: string;
    vat?: string;
    website?: string;
    role?: string;
    ean?: string;
    secretary?: SecretaryDto;
    groups?: GroupListViewDto[];
    agreement?: AgreementForOrganizationListViewDto[];
    supplier?: SupplierForOrganizationListViewDto[];
    subscriptionType?: string;
    subscriptionStartDate?: string;
    projectGroup?: ProjectGroupListViewDto[];
    shoppingCommunity?: ShoppingCommunityForCustomerList[];
    sourcingPrograms?: SourcingprogramListViewDto[];
    eOrderInfo?: EOrderDto;

    [key: string]: any;
}

export class OrganizationReference implements IOrganizationReference {
    organizationId!: string;

    [key: string]: any;

    constructor(data?: IOrganizationReference) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): OrganizationReference {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationReference();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IOrganizationReference {
    organizationId: string;

    [key: string]: any;
}

export class OrganizationRelationSummaryDto implements IOrganizationRelationSummaryDto {
    relationRoleName?: string;
    companyName?: string;
    companyType?: number | undefined;
    companyTypeName?: string;
    orgId?: string;
    cvrNumber?: string;

    [key: string]: any;

    constructor(data?: IOrganizationRelationSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.relationRoleName = _data["relationRoleName"];
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
            this.companyTypeName = _data["companyTypeName"];
            this.orgId = _data["orgId"];
            this.cvrNumber = _data["cvrNumber"];
        }
    }

    static fromJS(data: any): OrganizationRelationSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationRelationSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["relationRoleName"] = this.relationRoleName;
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        data["companyTypeName"] = this.companyTypeName;
        data["orgId"] = this.orgId;
        data["cvrNumber"] = this.cvrNumber;
        return data;
    }
}

export interface IOrganizationRelationSummaryDto {
    relationRoleName?: string;
    companyName?: string;
    companyType?: number | undefined;
    companyTypeName?: string;
    orgId?: string;
    cvrNumber?: string;

    [key: string]: any;
}

export class OrganizationSearchDto implements IOrganizationSearchDto {
    organizationId?: string;
    name?: string;
    cvrNumber?: string;
    eanNumber?: string;
    street?: string;
    postalCode?: string;
    city?: string;

    [key: string]: any;

    constructor(data?: IOrganizationSearchDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
            this.name = _data["name"];
            this.cvrNumber = _data["cvrNumber"];
            this.eanNumber = _data["eanNumber"];
            this.street = _data["street"];
            this.postalCode = _data["postalCode"];
            this.city = _data["city"];
        }
    }

    static fromJS(data: any): OrganizationSearchDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSearchDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        data["name"] = this.name;
        data["cvrNumber"] = this.cvrNumber;
        data["eanNumber"] = this.eanNumber;
        data["street"] = this.street;
        data["postalCode"] = this.postalCode;
        data["city"] = this.city;
        return data;
    }
}

export interface IOrganizationSearchDto {
    organizationId?: string;
    name?: string;
    cvrNumber?: string;
    eanNumber?: string;
    street?: string;
    postalCode?: string;
    city?: string;

    [key: string]: any;
}

export class OrganizationStructureDto implements IOrganizationStructureDto {
    childOrgs?: OrganizationStructureDto[];
    companyName?: string;
    companyType?: number | undefined;
    companyTypeName?: string;
    orgId?: string;
    cvrNumber?: string;

    [key: string]: any;

    constructor(data?: IOrganizationStructureDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["childOrgs"])) {
                this.childOrgs = [] as any;
                for (let item of _data["childOrgs"])
                    this.childOrgs!.push(OrganizationStructureDto.fromJS(item));
            }
            this.companyName = _data["companyName"];
            this.companyType = _data["companyType"];
            this.companyTypeName = _data["companyTypeName"];
            this.orgId = _data["orgId"];
            this.cvrNumber = _data["cvrNumber"];
        }
    }

    static fromJS(data: any): OrganizationStructureDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationStructureDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.childOrgs)) {
            data["childOrgs"] = [];
            for (let item of this.childOrgs)
                data["childOrgs"].push(item.toJSON());
        }
        data["companyName"] = this.companyName;
        data["companyType"] = this.companyType;
        data["companyTypeName"] = this.companyTypeName;
        data["orgId"] = this.orgId;
        data["cvrNumber"] = this.cvrNumber;
        return data;
    }
}

export interface IOrganizationStructureDto {
    childOrgs?: OrganizationStructureDto[];
    companyName?: string;
    companyType?: number | undefined;
    companyTypeName?: string;
    orgId?: string;
    cvrNumber?: string;

    [key: string]: any;
}

export class OrganizationSupplierReport implements IOrganizationSupplierReport {
    reportingCode?: number;
    supplierReportStartDate?: Date | undefined;
    supplierReportEndDate?: Date | undefined;
    paymentTermsCode?: string;
    navisionProjectCode?: string;
    sharePerUnit?: number | undefined;
    sharePercent?: number | undefined;
    autoApproveReports?: boolean;

    [key: string]: any;

    constructor(data?: IOrganizationSupplierReport) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.reportingCode = _data["reportingCode"];
            this.supplierReportStartDate = _data["supplierReportStartDate"] ? new Date(_data["supplierReportStartDate"].toString()) : <any>undefined;
            this.supplierReportEndDate = _data["supplierReportEndDate"] ? new Date(_data["supplierReportEndDate"].toString()) : <any>undefined;
            this.paymentTermsCode = _data["paymentTermsCode"];
            this.navisionProjectCode = _data["navisionProjectCode"];
            this.sharePerUnit = _data["sharePerUnit"];
            this.sharePercent = _data["sharePercent"];
            this.autoApproveReports = _data["autoApproveReports"];
        }
    }

    static fromJS(data: any): OrganizationSupplierReport {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationSupplierReport();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["reportingCode"] = this.reportingCode;
        data["supplierReportStartDate"] = this.supplierReportStartDate ? this.supplierReportStartDate.toISOString() : <any>undefined;
        data["supplierReportEndDate"] = this.supplierReportEndDate ? this.supplierReportEndDate.toISOString() : <any>undefined;
        data["paymentTermsCode"] = this.paymentTermsCode;
        data["navisionProjectCode"] = this.navisionProjectCode;
        data["sharePerUnit"] = this.sharePerUnit;
        data["sharePercent"] = this.sharePercent;
        data["autoApproveReports"] = this.autoApproveReports;
        return data;
    }
}

export interface IOrganizationSupplierReport {
    reportingCode?: number;
    supplierReportStartDate?: Date | undefined;
    supplierReportEndDate?: Date | undefined;
    paymentTermsCode?: string;
    navisionProjectCode?: string;
    sharePerUnit?: number | undefined;
    sharePercent?: number | undefined;
    autoApproveReports?: boolean;

    [key: string]: any;
}

export class ProblemDetails implements IProblemDetails {
    type?: string;
    title?: string;
    status?: number | undefined;
    detail?: string;
    instance?: string;
    extensions?: { [key: string]: any; };

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string;
    title?: string;
    status?: number | undefined;
    detail?: string;
    instance?: string;
    extensions?: { [key: string]: any; };

    [key: string]: any;
}

export class ProjectGroupListViewDto implements IProjectGroupListViewDto {
    agreementId?: string;
    agreementName?: string;
    name?: string;
    isMainAgreement?: boolean;
    jobTitle?: string;
    company?: string;
    telephone?: string;
    mail?: string;
    organizationId?: string;
    customerName?: string;
    url?: string;
    shoppingCommunity?: ShoppingCommunityListViewDto[];

    [key: string]: any;

    constructor(data?: IProjectGroupListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.agreementName = _data["agreementName"];
            this.name = _data["name"];
            this.isMainAgreement = _data["isMainAgreement"];
            this.jobTitle = _data["jobTitle"];
            this.company = _data["company"];
            this.telephone = _data["telephone"];
            this.mail = _data["mail"];
            this.organizationId = _data["organizationId"];
            this.customerName = _data["customerName"];
            this.url = _data["url"];
            if (Array.isArray(_data["shoppingCommunity"])) {
                this.shoppingCommunity = [] as any;
                for (let item of _data["shoppingCommunity"])
                    this.shoppingCommunity!.push(ShoppingCommunityListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectGroupListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectGroupListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["agreementName"] = this.agreementName;
        data["name"] = this.name;
        data["isMainAgreement"] = this.isMainAgreement;
        data["jobTitle"] = this.jobTitle;
        data["company"] = this.company;
        data["telephone"] = this.telephone;
        data["mail"] = this.mail;
        data["organizationId"] = this.organizationId;
        data["customerName"] = this.customerName;
        data["url"] = this.url;
        if (Array.isArray(this.shoppingCommunity)) {
            data["shoppingCommunity"] = [];
            for (let item of this.shoppingCommunity)
                data["shoppingCommunity"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectGroupListViewDto {
    agreementId?: string;
    agreementName?: string;
    name?: string;
    isMainAgreement?: boolean;
    jobTitle?: string;
    company?: string;
    telephone?: string;
    mail?: string;
    organizationId?: string;
    customerName?: string;
    url?: string;
    shoppingCommunity?: ShoppingCommunityListViewDto[];

    [key: string]: any;
}

export class RelatedAgreementsListViewDto implements IRelatedAgreementsListViewDto {
    agreementId?: string;
    fullName?: string;
    displayNameShort?: string;
    displayNumbers?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    url?: string;

    [key: string]: any;

    constructor(data?: IRelatedAgreementsListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.fullName = _data["fullName"];
            this.displayNameShort = _data["displayNameShort"];
            this.displayNumbers = _data["displayNumbers"];
            this.expirationDateUtc = _data["expirationDateUtc"];
            this.expirationDateMaxUtc = _data["expirationDateMaxUtc"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): RelatedAgreementsListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new RelatedAgreementsListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["fullName"] = this.fullName;
        data["displayNameShort"] = this.displayNameShort;
        data["displayNumbers"] = this.displayNumbers;
        data["expirationDateUtc"] = this.expirationDateUtc;
        data["expirationDateMaxUtc"] = this.expirationDateMaxUtc;
        data["url"] = this.url;
        return data;
    }
}

export interface IRelatedAgreementsListViewDto {
    agreementId?: string;
    fullName?: string;
    displayNameShort?: string;
    displayNumbers?: string;
    expirationDateUtc?: string;
    expirationDateMaxUtc?: string;
    url?: string;

    [key: string]: any;
}

export class ReportingRequirementAgreementDto implements IReportingRequirementAgreementDto {
    id?: string;
    name?: string;
    href?: string;
    mainAgreementId?: string;

    [key: string]: any;

    constructor(data?: IReportingRequirementAgreementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.name = _data["name"];
            this.href = _data["href"];
            this.mainAgreementId = _data["mainAgreementId"];
        }
    }

    static fromJS(data: any): ReportingRequirementAgreementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingRequirementAgreementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["name"] = this.name;
        data["href"] = this.href;
        data["mainAgreementId"] = this.mainAgreementId;
        return data;
    }
}

export interface IReportingRequirementAgreementDto {
    id?: string;
    name?: string;
    href?: string;
    mainAgreementId?: string;

    [key: string]: any;
}

export class ReportingRequirementDto implements IReportingRequirementDto {
    agreement?: ReportingRequirementAgreementDto;
    startDate?: string;
    endDate?: string;

    [key: string]: any;

    constructor(data?: IReportingRequirementDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreement = _data["agreement"] ? ReportingRequirementAgreementDto.fromJS(_data["agreement"]) : <any>undefined;
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
        }
    }

    static fromJS(data: any): ReportingRequirementDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingRequirementDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreement"] = this.agreement ? this.agreement.toJSON() : <any>undefined;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        return data;
    }
}

export interface IReportingRequirementDto {
    agreement?: ReportingRequirementAgreementDto;
    startDate?: string;
    endDate?: string;

    [key: string]: any;
}

export class ReportingRequirementsWrapper implements IReportingRequirementsWrapper {
    reportingRequirements?: ReportingRequirementDto[];
    contacts?: ReportingResponsibleDto[];

    [key: string]: any;

    constructor(data?: IReportingRequirementsWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["reportingRequirements"])) {
                this.reportingRequirements = [] as any;
                for (let item of _data["reportingRequirements"])
                    this.reportingRequirements!.push(ReportingRequirementDto.fromJS(item));
            }
            if (Array.isArray(_data["contacts"])) {
                this.contacts = [] as any;
                for (let item of _data["contacts"])
                    this.contacts!.push(ReportingResponsibleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportingRequirementsWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingRequirementsWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.reportingRequirements)) {
            data["reportingRequirements"] = [];
            for (let item of this.reportingRequirements)
                data["reportingRequirements"].push(item.toJSON());
        }
        if (Array.isArray(this.contacts)) {
            data["contacts"] = [];
            for (let item of this.contacts)
                data["contacts"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportingRequirementsWrapper {
    reportingRequirements?: ReportingRequirementDto[];
    contacts?: ReportingResponsibleDto[];

    [key: string]: any;
}

export class ReportingResponsibleDto implements IReportingResponsibleDto {
    name?: string;
    email?: string;

    [key: string]: any;

    constructor(data?: IReportingResponsibleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ReportingResponsibleDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingResponsibleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["email"] = this.email;
        return data;
    }
}

export interface IReportingResponsibleDto {
    name?: string;
    email?: string;

    [key: string]: any;
}

export class SecretaryDto implements ISecretaryDto {
    organizationId?: string;
    url?: string;

    [key: string]: any;

    constructor(data?: ISecretaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): SecretaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new SecretaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        data["url"] = this.url;
        return data;
    }
}

export interface ISecretaryDto {
    organizationId?: string;
    url?: string;

    [key: string]: any;
}

export class ShoppingCommunityForCustomerList implements IShoppingCommunityForCustomerList {
    organization?: string;
    url?: string;
    organizationId?: string;

    [key: string]: any;

    constructor(data?: IShoppingCommunityForCustomerList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organization = _data["organization"];
            this.url = _data["url"];
            this.organizationId = _data["organizationId"];
        }
    }

    static fromJS(data: any): ShoppingCommunityForCustomerList {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCommunityForCustomerList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organization"] = this.organization;
        data["url"] = this.url;
        data["organizationId"] = this.organizationId;
        return data;
    }
}

export interface IShoppingCommunityForCustomerList {
    organization?: string;
    url?: string;
    organizationId?: string;

    [key: string]: any;
}

export class ShoppingCommunityListViewDto implements IShoppingCommunityListViewDto {
    name?: string;

    [key: string]: any;

    constructor(data?: IShoppingCommunityListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ShoppingCommunityListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ShoppingCommunityListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface IShoppingCommunityListViewDto {
    name?: string;

    [key: string]: any;
}

export class SkiAgreementRequest implements ISkiAgreementRequest {
    aftid!: string;

    [key: string]: any;

    constructor(data?: ISkiAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.aftid = _data["aftid"];
        }
    }

    static fromJS(data: any): SkiAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SkiAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["aftid"] = this.aftid;
        return data;
    }
}

export interface ISkiAgreementRequest {
    aftid: string;

    [key: string]: any;
}

export class SkiApprovalsListViewDto implements ISkiApprovalsListViewDto {
    id?: string;
    title?: string;

    [key: string]: any;

    constructor(data?: ISkiApprovalsListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.id = _data["id"];
            this.title = _data["title"];
        }
    }

    static fromJS(data: any): SkiApprovalsListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkiApprovalsListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["id"] = this.id;
        data["title"] = this.title;
        return data;
    }
}

export interface ISkiApprovalsListViewDto {
    id?: string;
    title?: string;

    [key: string]: any;
}

export class SkiOverallstatusListViewDto implements ISkiOverallstatusListViewDto {
    name?: string;

    [key: string]: any;

    constructor(data?: ISkiOverallstatusListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SkiOverallstatusListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkiOverallstatusListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ISkiOverallstatusListViewDto {
    name?: string;

    [key: string]: any;
}

export class SkiResponsibleListViewDto implements ISkiResponsibleListViewDto {
    role?: string;
    contact?: ContactListViewDto;
    orderNumber?: number | undefined;
    skiStartdato?: Date | undefined;
    skiSlutdato?: Date | undefined;

    [key: string]: any;

    constructor(data?: ISkiResponsibleListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            this.contact = _data["contact"] ? ContactListViewDto.fromJS(_data["contact"]) : <any>undefined;
            this.orderNumber = _data["orderNumber"];
            this.skiStartdato = _data["skiStartdato"] ? new Date(_data["skiStartdato"].toString()) : <any>undefined;
            this.skiSlutdato = _data["skiSlutdato"] ? new Date(_data["skiSlutdato"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): SkiResponsibleListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SkiResponsibleListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        data["contact"] = this.contact ? this.contact.toJSON() : <any>undefined;
        data["orderNumber"] = this.orderNumber;
        data["skiStartdato"] = this.skiStartdato ? this.skiStartdato.toISOString() : <any>undefined;
        data["skiSlutdato"] = this.skiSlutdato ? this.skiSlutdato.toISOString() : <any>undefined;
        return data;
    }
}

export interface ISkiResponsibleListViewDto {
    role?: string;
    contact?: ContactListViewDto;
    orderNumber?: number | undefined;
    skiStartdato?: Date | undefined;
    skiSlutdato?: Date | undefined;

    [key: string]: any;
}

export class SkiStatusupdate implements ISkiStatusupdate {
    skiStatusupdateId?: string;
    skiName?: string;
    skiRequireslogin?: boolean | undefined;
    skiRequiresloginName?: string;
    skiStartdate?: Date | undefined;
    skiEnddate?: Date | undefined;
    skiApproval?: number | undefined;
    skiApprovalName?: string;
    skiText?: string;
    skiStatusupdateautoid?: string;
    skiStatusupdatecategory?: string | undefined;
    skiStatusupdatecategoryName?: string;
    abaGenudsendelse?: boolean | undefined;
    abaGenudsendelseName?: string;
    abaPreheader?: string;
    abaEmailtemplateId?: string | undefined;
    abaEmailtemplateIdName?: string;
    abaRelateredeSkiaftalerhtml?: string;
    abaStausopdateringurl?: string;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOnBehalfBy?: string | undefined;
    modifiedOnBehalfBy?: string | undefined;
    createdByName?: string;
    createdByYomiName?: string;
    createdOnBehalfByName?: string;
    createdOnBehalfByYomiName?: string;
    modifiedByName?: string;
    modifiedByYomiName?: string;
    modifiedOnBehalfByName?: string;
    modifiedOnBehalfByYomiName?: string;
    organizationId?: string | undefined;
    organizationIdName?: string;
    statecode?: string;
    statecodeName?: string;
    statuscode?: string;
    statuscodeName?: string;
    versionNumber?: number | undefined;
    importSequenceNumber?: number | undefined;
    overriddenCreatedOn?: Date | undefined;
    timeZoneRuleVersionNumber?: number | undefined;
    utcconversionTimeZoneCode?: number | undefined;
    requestId?: string | undefined;

    [key: string]: any;

    constructor(data?: ISkiStatusupdate) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.skiStatusupdateId = _data["skiStatusupdateId"];
            this.skiName = _data["skiName"];
            this.skiRequireslogin = _data["skiRequireslogin"];
            this.skiRequiresloginName = _data["skiRequiresloginName"];
            this.skiStartdate = _data["skiStartdate"] ? new Date(_data["skiStartdate"].toString()) : <any>undefined;
            this.skiEnddate = _data["skiEnddate"] ? new Date(_data["skiEnddate"].toString()) : <any>undefined;
            this.skiApproval = _data["skiApproval"];
            this.skiApprovalName = _data["skiApprovalName"];
            this.skiText = _data["skiText"];
            this.skiStatusupdateautoid = _data["skiStatusupdateautoid"];
            this.skiStatusupdatecategory = _data["skiStatusupdatecategory"];
            this.skiStatusupdatecategoryName = _data["skiStatusupdatecategoryName"];
            this.abaGenudsendelse = _data["abaGenudsendelse"];
            this.abaGenudsendelseName = _data["abaGenudsendelseName"];
            this.abaPreheader = _data["abaPreheader"];
            this.abaEmailtemplateId = _data["abaEmailtemplateId"];
            this.abaEmailtemplateIdName = _data["abaEmailtemplateIdName"];
            this.abaRelateredeSkiaftalerhtml = _data["abaRelateredeSkiaftalerhtml"];
            this.abaStausopdateringurl = _data["abaStausopdateringurl"];
            this.deletedOn = _data["deletedOn"] ? new Date(_data["deletedOn"].toString()) : <any>undefined;
            this.deletedBy = _data["deletedBy"];
            this.createdOn = _data["createdOn"] ? new Date(_data["createdOn"].toString()) : <any>undefined;
            this.createdBy = _data["createdBy"];
            this.modifiedOn = _data["modifiedOn"] ? new Date(_data["modifiedOn"].toString()) : <any>undefined;
            this.modifiedBy = _data["modifiedBy"];
            this.createdOnBehalfBy = _data["createdOnBehalfBy"];
            this.modifiedOnBehalfBy = _data["modifiedOnBehalfBy"];
            this.createdByName = _data["createdByName"];
            this.createdByYomiName = _data["createdByYomiName"];
            this.createdOnBehalfByName = _data["createdOnBehalfByName"];
            this.createdOnBehalfByYomiName = _data["createdOnBehalfByYomiName"];
            this.modifiedByName = _data["modifiedByName"];
            this.modifiedByYomiName = _data["modifiedByYomiName"];
            this.modifiedOnBehalfByName = _data["modifiedOnBehalfByName"];
            this.modifiedOnBehalfByYomiName = _data["modifiedOnBehalfByYomiName"];
            this.organizationId = _data["organizationId"];
            this.organizationIdName = _data["organizationIdName"];
            this.statecode = _data["statecode"];
            this.statecodeName = _data["statecodeName"];
            this.statuscode = _data["statuscode"];
            this.statuscodeName = _data["statuscodeName"];
            this.versionNumber = _data["versionNumber"];
            this.importSequenceNumber = _data["importSequenceNumber"];
            this.overriddenCreatedOn = _data["overriddenCreatedOn"] ? new Date(_data["overriddenCreatedOn"].toString()) : <any>undefined;
            this.timeZoneRuleVersionNumber = _data["timeZoneRuleVersionNumber"];
            this.utcconversionTimeZoneCode = _data["utcconversionTimeZoneCode"];
            this.requestId = _data["requestId"];
        }
    }

    static fromJS(data: any): SkiStatusupdate {
        data = typeof data === 'object' ? data : {};
        let result = new SkiStatusupdate();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["skiStatusupdateId"] = this.skiStatusupdateId;
        data["skiName"] = this.skiName;
        data["skiRequireslogin"] = this.skiRequireslogin;
        data["skiRequiresloginName"] = this.skiRequiresloginName;
        data["skiStartdate"] = this.skiStartdate ? this.skiStartdate.toISOString() : <any>undefined;
        data["skiEnddate"] = this.skiEnddate ? this.skiEnddate.toISOString() : <any>undefined;
        data["skiApproval"] = this.skiApproval;
        data["skiApprovalName"] = this.skiApprovalName;
        data["skiText"] = this.skiText;
        data["skiStatusupdateautoid"] = this.skiStatusupdateautoid;
        data["skiStatusupdatecategory"] = this.skiStatusupdatecategory;
        data["skiStatusupdatecategoryName"] = this.skiStatusupdatecategoryName;
        data["abaGenudsendelse"] = this.abaGenudsendelse;
        data["abaGenudsendelseName"] = this.abaGenudsendelseName;
        data["abaPreheader"] = this.abaPreheader;
        data["abaEmailtemplateId"] = this.abaEmailtemplateId;
        data["abaEmailtemplateIdName"] = this.abaEmailtemplateIdName;
        data["abaRelateredeSkiaftalerhtml"] = this.abaRelateredeSkiaftalerhtml;
        data["abaStausopdateringurl"] = this.abaStausopdateringurl;
        data["deletedOn"] = this.deletedOn ? this.deletedOn.toISOString() : <any>undefined;
        data["deletedBy"] = this.deletedBy;
        data["createdOn"] = this.createdOn ? this.createdOn.toISOString() : <any>undefined;
        data["createdBy"] = this.createdBy;
        data["modifiedOn"] = this.modifiedOn ? this.modifiedOn.toISOString() : <any>undefined;
        data["modifiedBy"] = this.modifiedBy;
        data["createdOnBehalfBy"] = this.createdOnBehalfBy;
        data["modifiedOnBehalfBy"] = this.modifiedOnBehalfBy;
        data["createdByName"] = this.createdByName;
        data["createdByYomiName"] = this.createdByYomiName;
        data["createdOnBehalfByName"] = this.createdOnBehalfByName;
        data["createdOnBehalfByYomiName"] = this.createdOnBehalfByYomiName;
        data["modifiedByName"] = this.modifiedByName;
        data["modifiedByYomiName"] = this.modifiedByYomiName;
        data["modifiedOnBehalfByName"] = this.modifiedOnBehalfByName;
        data["modifiedOnBehalfByYomiName"] = this.modifiedOnBehalfByYomiName;
        data["organizationId"] = this.organizationId;
        data["organizationIdName"] = this.organizationIdName;
        data["statecode"] = this.statecode;
        data["statecodeName"] = this.statecodeName;
        data["statuscode"] = this.statuscode;
        data["statuscodeName"] = this.statuscodeName;
        data["versionNumber"] = this.versionNumber;
        data["importSequenceNumber"] = this.importSequenceNumber;
        data["overriddenCreatedOn"] = this.overriddenCreatedOn ? this.overriddenCreatedOn.toISOString() : <any>undefined;
        data["timeZoneRuleVersionNumber"] = this.timeZoneRuleVersionNumber;
        data["utcconversionTimeZoneCode"] = this.utcconversionTimeZoneCode;
        data["requestId"] = this.requestId;
        return data;
    }
}

export interface ISkiStatusupdate {
    skiStatusupdateId?: string;
    skiName?: string;
    skiRequireslogin?: boolean | undefined;
    skiRequiresloginName?: string;
    skiStartdate?: Date | undefined;
    skiEnddate?: Date | undefined;
    skiApproval?: number | undefined;
    skiApprovalName?: string;
    skiText?: string;
    skiStatusupdateautoid?: string;
    skiStatusupdatecategory?: string | undefined;
    skiStatusupdatecategoryName?: string;
    abaGenudsendelse?: boolean | undefined;
    abaGenudsendelseName?: string;
    abaPreheader?: string;
    abaEmailtemplateId?: string | undefined;
    abaEmailtemplateIdName?: string;
    abaRelateredeSkiaftalerhtml?: string;
    abaStausopdateringurl?: string;
    deletedOn?: Date | undefined;
    deletedBy?: string | undefined;
    createdOn?: Date | undefined;
    createdBy?: string | undefined;
    modifiedOn?: Date | undefined;
    modifiedBy?: string | undefined;
    createdOnBehalfBy?: string | undefined;
    modifiedOnBehalfBy?: string | undefined;
    createdByName?: string;
    createdByYomiName?: string;
    createdOnBehalfByName?: string;
    createdOnBehalfByYomiName?: string;
    modifiedByName?: string;
    modifiedByYomiName?: string;
    modifiedOnBehalfByName?: string;
    modifiedOnBehalfByYomiName?: string;
    organizationId?: string | undefined;
    organizationIdName?: string;
    statecode?: string;
    statecodeName?: string;
    statuscode?: string;
    statuscodeName?: string;
    versionNumber?: number | undefined;
    importSequenceNumber?: number | undefined;
    overriddenCreatedOn?: Date | undefined;
    timeZoneRuleVersionNumber?: number | undefined;
    utcconversionTimeZoneCode?: number | undefined;
    requestId?: string | undefined;

    [key: string]: any;
}

export class SourcingprogramListViewDto implements ISourcingprogramListViewDto {
    name?: string;

    [key: string]: any;

    constructor(data?: ISourcingprogramListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SourcingprogramListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SourcingprogramListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        return data;
    }
}

export interface ISourcingprogramListViewDto {
    name?: string;

    [key: string]: any;
}

export class StatusupdateListViewDto implements IStatusupdateListViewDto {
    agreementStatusUpdate?: AgreementStatusUpdateDto[];
    category?: string[];

    [key: string]: any;

    constructor(data?: IStatusupdateListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["agreementStatusUpdate"])) {
                this.agreementStatusUpdate = [] as any;
                for (let item of _data["agreementStatusUpdate"])
                    this.agreementStatusUpdate!.push(AgreementStatusUpdateDto.fromJS(item));
            }
            if (Array.isArray(_data["category"])) {
                this.category = [] as any;
                for (let item of _data["category"])
                    this.category!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusupdateListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusupdateListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.agreementStatusUpdate)) {
            data["agreementStatusUpdate"] = [];
            for (let item of this.agreementStatusUpdate)
                data["agreementStatusUpdate"].push(item.toJSON());
        }
        if (Array.isArray(this.category)) {
            data["category"] = [];
            for (let item of this.category)
                data["category"].push(item);
        }
        return data;
    }
}

export interface IStatusupdateListViewDto {
    agreementStatusUpdate?: AgreementStatusUpdateDto[];
    category?: string[];

    [key: string]: any;
}

export class StatusUpdateProgress implements IStatusUpdateProgress {
    message?: string;
    status?: StatusUpdateProgressStatus;
    instanceId?: string;

    [key: string]: any;

    constructor(data?: IStatusUpdateProgress) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.status = StatusUpdateProgressStatus._0;
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.message = _data["message"];
            this.status = _data["status"] !== undefined ? _data["status"] : StatusUpdateProgressStatus._0;
            this.instanceId = _data["instanceId"];
        }
    }

    static fromJS(data: any): StatusUpdateProgress {
        data = typeof data === 'object' ? data : {};
        let result = new StatusUpdateProgress();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["message"] = this.message;
        data["status"] = this.status;
        data["instanceId"] = this.instanceId;
        return data;
    }
}

export interface IStatusUpdateProgress {
    message?: string;
    status?: StatusUpdateProgressStatus;
    instanceId?: string;

    [key: string]: any;
}

export class StatusUpdatesRequest implements IStatusUpdatesRequest {
    aftids!: string[];

    [key: string]: any;

    constructor(data?: IStatusUpdatesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.aftids = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["aftids"])) {
                this.aftids = [] as any;
                for (let item of _data["aftids"])
                    this.aftids!.push(item);
            }
        }
    }

    static fromJS(data: any): StatusUpdatesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatusUpdatesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.aftids)) {
            data["aftids"] = [];
            for (let item of this.aftids)
                data["aftids"].push(item);
        }
        return data;
    }
}

export interface IStatusUpdatesRequest {
    aftids: string[];

    [key: string]: any;
}

export class StatusUpdateViewDto implements IStatusUpdateViewDto {
    name?: string;
    category?: string;
    startDateUtc?: string;
    description?: string;
    agreements?: AgreementListStatusUpdateDto[];

    [key: string]: any;

    constructor(data?: IStatusUpdateViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.category = _data["category"];
            this.startDateUtc = _data["startDateUtc"];
            this.description = _data["description"];
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(AgreementListStatusUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StatusUpdateViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new StatusUpdateViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["category"] = this.category;
        data["startDateUtc"] = this.startDateUtc;
        data["description"] = this.description;
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStatusUpdateViewDto {
    name?: string;
    category?: string;
    startDateUtc?: string;
    description?: string;
    agreements?: AgreementListStatusUpdateDto[];

    [key: string]: any;
}

export class SubagreementListViewDto implements ISubagreementListViewDto {
    displayNameLong?: string;
    subAgreementName?: string;
    subAgreementNumber?: string;
    subAgreementId?: string;
    url?: string;
    keywords?: KeywordDto[];
    overallStatusName?: string;
    customerApplication?: CustomerApplicationListViewDto;
    skiNextMilestone?: NextMilestoneListViewDto;
    alternateDisplayDate?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    intoForceDateUtc?: string;
    showOnAgreement?: boolean | undefined;
    phase?: string;
    eCatalogOnAgreement?: boolean | undefined;
    id?: string;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationDate?: Date | undefined;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;

    constructor(data?: ISubagreementListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.displayNameLong = _data["displayNameLong"];
            this.subAgreementName = _data["subAgreementName"];
            this.subAgreementNumber = _data["subAgreementNumber"];
            this.subAgreementId = _data["subAgreementId"];
            this.url = _data["url"];
            if (Array.isArray(_data["keywords"])) {
                this.keywords = [] as any;
                for (let item of _data["keywords"])
                    this.keywords!.push(KeywordDto.fromJS(item));
            }
            this.overallStatusName = _data["overallStatusName"];
            this.customerApplication = _data["customerApplication"] ? CustomerApplicationListViewDto.fromJS(_data["customerApplication"]) : <any>undefined;
            this.skiNextMilestone = _data["skiNextMilestone"] ? NextMilestoneListViewDto.fromJS(_data["skiNextMilestone"]) : <any>undefined;
            this.alternateDisplayDate = _data["alternateDisplayDate"];
            this.expectedIntoForceAlternateDisplayDate = _data["expectedIntoForceAlternateDisplayDate"];
            this.expectedIntoForceStartDateUtc = _data["expectedIntoForceStartDateUtc"];
            this.intoForceDateUtc = _data["intoForceDateUtc"];
            this.showOnAgreement = _data["showOnAgreement"];
            this.phase = _data["phase"];
            this.eCatalogOnAgreement = _data["eCatalogOnAgreement"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.nameWithYear = _data["nameWithYear"];
            this.frameworkAgreementAreaNumber = _data["frameworkAgreementAreaNumber"];
            this.frameworkAgreementNumber = _data["frameworkAgreementNumber"];
            this.partialAgreementNumber = _data["partialAgreementNumber"];
            this.frameworkAgreementYear = _data["frameworkAgreementYear"];
            this.combinedAgreementNumber = _data["combinedAgreementNumber"];
            this.agreementId = _data["agreementId"];
            this.expirationDate = _data["expirationDate"] ? new Date(_data["expirationDate"].toString()) : <any>undefined;
            this.expirationIncOptionsDate = _data["expirationIncOptionsDate"] ? new Date(_data["expirationIncOptionsDate"].toString()) : <any>undefined;
            this.showDisButton = _data["showDisButton"];
            this.disButtonUrl = _data["disButtonUrl"];
            this.disButtonText = _data["disButtonText"];
        }
    }

    static fromJS(data: any): SubagreementListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SubagreementListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["displayNameLong"] = this.displayNameLong;
        data["subAgreementName"] = this.subAgreementName;
        data["subAgreementNumber"] = this.subAgreementNumber;
        data["subAgreementId"] = this.subAgreementId;
        data["url"] = this.url;
        if (Array.isArray(this.keywords)) {
            data["keywords"] = [];
            for (let item of this.keywords)
                data["keywords"].push(item.toJSON());
        }
        data["overallStatusName"] = this.overallStatusName;
        data["customerApplication"] = this.customerApplication ? this.customerApplication.toJSON() : <any>undefined;
        data["skiNextMilestone"] = this.skiNextMilestone ? this.skiNextMilestone.toJSON() : <any>undefined;
        data["alternateDisplayDate"] = this.alternateDisplayDate;
        data["expectedIntoForceAlternateDisplayDate"] = this.expectedIntoForceAlternateDisplayDate;
        data["expectedIntoForceStartDateUtc"] = this.expectedIntoForceStartDateUtc;
        data["intoForceDateUtc"] = this.intoForceDateUtc;
        data["showOnAgreement"] = this.showOnAgreement;
        data["phase"] = this.phase;
        data["eCatalogOnAgreement"] = this.eCatalogOnAgreement;
        data["id"] = this.id;
        data["name"] = this.name;
        data["nameWithYear"] = this.nameWithYear;
        data["frameworkAgreementAreaNumber"] = this.frameworkAgreementAreaNumber;
        data["frameworkAgreementNumber"] = this.frameworkAgreementNumber;
        data["partialAgreementNumber"] = this.partialAgreementNumber;
        data["frameworkAgreementYear"] = this.frameworkAgreementYear;
        data["combinedAgreementNumber"] = this.combinedAgreementNumber;
        data["agreementId"] = this.agreementId;
        data["expirationDate"] = this.expirationDate ? formatDate(this.expirationDate) : <any>undefined;
        data["expirationIncOptionsDate"] = this.expirationIncOptionsDate ? formatDate(this.expirationIncOptionsDate) : <any>undefined;
        data["showDisButton"] = this.showDisButton;
        data["disButtonUrl"] = this.disButtonUrl;
        data["disButtonText"] = this.disButtonText;
        return data;
    }
}

export interface ISubagreementListViewDto {
    displayNameLong?: string;
    subAgreementName?: string;
    subAgreementNumber?: string;
    subAgreementId?: string;
    url?: string;
    keywords?: KeywordDto[];
    overallStatusName?: string;
    customerApplication?: CustomerApplicationListViewDto;
    skiNextMilestone?: NextMilestoneListViewDto;
    alternateDisplayDate?: string;
    expectedIntoForceAlternateDisplayDate?: string;
    expectedIntoForceStartDateUtc?: string;
    intoForceDateUtc?: string;
    showOnAgreement?: boolean | undefined;
    phase?: string;
    eCatalogOnAgreement?: boolean | undefined;
    id?: string;
    name?: string;
    nameWithYear?: string;
    frameworkAgreementAreaNumber?: string;
    frameworkAgreementNumber?: string;
    partialAgreementNumber?: string;
    frameworkAgreementYear?: string;
    combinedAgreementNumber?: string;
    agreementId?: string;
    expirationDate?: Date | undefined;
    expirationIncOptionsDate?: Date | undefined;
    showDisButton?: boolean;
    disButtonUrl?: string;
    disButtonText?: string;

    [key: string]: any;
}

export class Supplier implements ISupplier {
    organizationId?: string;
    supplierName?: string;

    [key: string]: any;

    constructor(data?: ISupplier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
            this.supplierName = _data["supplierName"];
        }
    }

    static fromJS(data: any): Supplier {
        data = typeof data === 'object' ? data : {};
        let result = new Supplier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        data["supplierName"] = this.supplierName;
        return data;
    }
}

export interface ISupplier {
    organizationId?: string;
    supplierName?: string;

    [key: string]: any;
}

export class SupplierForOrganizationListViewDto implements ISupplierForOrganizationListViewDto {
    organizationId?: string;
    url?: string;
    name?: string;
    addressName?: string;
    street?: string;
    postalcode?: string;
    city?: string;
    country?: string;
    mail?: string;
    cvr?: string;
    website?: string;
    role?: string;
    ean?: string;

    [key: string]: any;

    constructor(data?: ISupplierForOrganizationListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.organizationId = _data["organizationId"];
            this.url = _data["url"];
            this.name = _data["name"];
            this.addressName = _data["addressName"];
            this.street = _data["street"];
            this.postalcode = _data["postalcode"];
            this.city = _data["city"];
            this.country = _data["country"];
            this.mail = _data["mail"];
            this.cvr = _data["cvr"];
            this.website = _data["website"];
            this.role = _data["role"];
            this.ean = _data["ean"];
        }
    }

    static fromJS(data: any): SupplierForOrganizationListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierForOrganizationListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["organizationId"] = this.organizationId;
        data["url"] = this.url;
        data["name"] = this.name;
        data["addressName"] = this.addressName;
        data["street"] = this.street;
        data["postalcode"] = this.postalcode;
        data["city"] = this.city;
        data["country"] = this.country;
        data["mail"] = this.mail;
        data["cvr"] = this.cvr;
        data["website"] = this.website;
        data["role"] = this.role;
        data["ean"] = this.ean;
        return data;
    }
}

export interface ISupplierForOrganizationListViewDto {
    organizationId?: string;
    url?: string;
    name?: string;
    addressName?: string;
    street?: string;
    postalcode?: string;
    city?: string;
    country?: string;
    mail?: string;
    cvr?: string;
    website?: string;
    role?: string;
    ean?: string;

    [key: string]: any;
}

export class SupplierListViewDto implements ISupplierListViewDto {
    supplierName?: string;
    url?: string;
    supplyRoles?: SupplyRoleListViewDto[];
    organizationId?: string;
    cvrNummer?: string;

    [key: string]: any;

    constructor(data?: ISupplierListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.supplierName = _data["supplierName"];
            this.url = _data["url"];
            if (Array.isArray(_data["supplyRoles"])) {
                this.supplyRoles = [] as any;
                for (let item of _data["supplyRoles"])
                    this.supplyRoles!.push(SupplyRoleListViewDto.fromJS(item));
            }
            this.organizationId = _data["organizationId"];
            this.cvrNummer = _data["cvrNummer"];
        }
    }

    static fromJS(data: any): SupplierListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["supplierName"] = this.supplierName;
        data["url"] = this.url;
        if (Array.isArray(this.supplyRoles)) {
            data["supplyRoles"] = [];
            for (let item of this.supplyRoles)
                data["supplyRoles"].push(item.toJSON());
        }
        data["organizationId"] = this.organizationId;
        data["cvrNummer"] = this.cvrNummer;
        return data;
    }
}

export interface ISupplierListViewDto {
    supplierName?: string;
    url?: string;
    supplyRoles?: SupplyRoleListViewDto[];
    organizationId?: string;
    cvrNummer?: string;

    [key: string]: any;
}

export class SupplierListViewDtoWrapper implements ISupplierListViewDtoWrapper {
    suppliers?: EnrichedSupplierListViewDto[];

    [key: string]: any;

    constructor(data?: ISupplierListViewDtoWrapper) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["suppliers"])) {
                this.suppliers = [] as any;
                for (let item of _data["suppliers"])
                    this.suppliers!.push(EnrichedSupplierListViewDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SupplierListViewDtoWrapper {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierListViewDtoWrapper();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.suppliers)) {
            data["suppliers"] = [];
            for (let item of this.suppliers)
                data["suppliers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISupplierListViewDtoWrapper {
    suppliers?: EnrichedSupplierListViewDto[];

    [key: string]: any;
}

export class SupplierReportDto implements ISupplierReportDto {
    supplierReportGuid?: string;
    supplierReporteportingCode?: number | undefined;
    supplierReportShareProcent?: number | undefined;
    supplierReportSharePerUnit?: number | undefined;
    supplierReportStartDate?: Date | undefined;
    supplierReportEndate?: Date | undefined;
    autoApproveReports?: boolean;

    [key: string]: any;

    constructor(data?: ISupplierReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.supplierReportGuid = _data["supplierReportGuid"];
            this.supplierReporteportingCode = _data["supplierReporteportingCode"];
            this.supplierReportShareProcent = _data["supplierReportShareProcent"];
            this.supplierReportSharePerUnit = _data["supplierReportSharePerUnit"];
            this.supplierReportStartDate = _data["supplierReportStartDate"] ? new Date(_data["supplierReportStartDate"].toString()) : <any>undefined;
            this.supplierReportEndate = _data["supplierReportEndate"] ? new Date(_data["supplierReportEndate"].toString()) : <any>undefined;
            this.autoApproveReports = _data["autoApproveReports"];
        }
    }

    static fromJS(data: any): SupplierReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["supplierReportGuid"] = this.supplierReportGuid;
        data["supplierReporteportingCode"] = this.supplierReporteportingCode;
        data["supplierReportShareProcent"] = this.supplierReportShareProcent;
        data["supplierReportSharePerUnit"] = this.supplierReportSharePerUnit;
        data["supplierReportStartDate"] = this.supplierReportStartDate ? this.supplierReportStartDate.toISOString() : <any>undefined;
        data["supplierReportEndate"] = this.supplierReportEndate ? this.supplierReportEndate.toISOString() : <any>undefined;
        data["autoApproveReports"] = this.autoApproveReports;
        return data;
    }
}

export interface ISupplierReportDto {
    supplierReportGuid?: string;
    supplierReporteportingCode?: number | undefined;
    supplierReportShareProcent?: number | undefined;
    supplierReportSharePerUnit?: number | undefined;
    supplierReportStartDate?: Date | undefined;
    supplierReportEndate?: Date | undefined;
    autoApproveReports?: boolean;

    [key: string]: any;
}

export class SupplierWithAgreement implements ISupplierWithAgreement {
    agreementId?: string;
    supplierOrgId?: string;
    agreementName?: string;

    [key: string]: any;

    constructor(data?: ISupplierWithAgreement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.agreementId = _data["agreementId"];
            this.supplierOrgId = _data["supplierOrgId"];
            this.agreementName = _data["agreementName"];
        }
    }

    static fromJS(data: any): SupplierWithAgreement {
        data = typeof data === 'object' ? data : {};
        let result = new SupplierWithAgreement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["agreementId"] = this.agreementId;
        data["supplierOrgId"] = this.supplierOrgId;
        data["agreementName"] = this.agreementName;
        return data;
    }
}

export interface ISupplierWithAgreement {
    agreementId?: string;
    supplierOrgId?: string;
    agreementName?: string;

    [key: string]: any;
}

export class SupplyRoleListViewDto implements ISupplyRoleListViewDto {
    role?: string;
    name?: string;
    phone?: string;
    email?: string;
    jobTitle?: string;

    [key: string]: any;

    constructor(data?: ISupplyRoleListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.role = _data["role"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.jobTitle = _data["jobTitle"];
        }
    }

    static fromJS(data: any): SupplyRoleListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new SupplyRoleListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["role"] = this.role;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["jobTitle"] = this.jobTitle;
        return data;
    }
}

export interface ISupplyRoleListViewDto {
    role?: string;
    name?: string;
    phone?: string;
    email?: string;
    jobTitle?: string;

    [key: string]: any;
}

export class TeamListViewDto implements ITeamListViewDto {
    skiName?: string;
    skiDescription?: string;
    skiOrdernumber?: number | undefined;

    [key: string]: any;

    constructor(data?: ITeamListViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.skiName = _data["skiName"];
            this.skiDescription = _data["skiDescription"];
            this.skiOrdernumber = _data["skiOrdernumber"];
        }
    }

    static fromJS(data: any): TeamListViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new TeamListViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["skiName"] = this.skiName;
        data["skiDescription"] = this.skiDescription;
        data["skiOrdernumber"] = this.skiOrdernumber;
        return data;
    }
}

export interface ITeamListViewDto {
    skiName?: string;
    skiDescription?: string;
    skiOrdernumber?: number | undefined;

    [key: string]: any;
}

export class TrafficLightOutputDto implements ITrafficLightOutputDto {
    applicationType?: string;
    applicationLabel?: string;
    applicationDescription?: string;
    conditionsDescription?: string;
    selectedApplicationOption?: string;
    agreementId?: string;
    mainAgreementGuid?: string | undefined;
    aftaleKundeStartDate?: Date | undefined;
    aftaleKundeEndDate?: Date | undefined;
    endOfLateSignUpPeriod?: Date | undefined;
    expirationDateMaxUtc?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    agreementName?: string;
    customerCvr?: string;
    customerOrgId?: string;
    customerId?: string;
    customerName?: string;
    agreementGuid?: string;

    [key: string]: any;

    constructor(data?: ITrafficLightOutputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.applicationType = _data["applicationType"];
            this.applicationLabel = _data["applicationLabel"];
            this.applicationDescription = _data["applicationDescription"];
            this.conditionsDescription = _data["conditionsDescription"];
            this.selectedApplicationOption = _data["selectedApplicationOption"];
            this.agreementId = _data["agreementId"];
            this.mainAgreementGuid = _data["mainAgreementGuid"];
            this.aftaleKundeStartDate = _data["aftaleKundeStartDate"] ? new Date(_data["aftaleKundeStartDate"].toString()) : <any>undefined;
            this.aftaleKundeEndDate = _data["aftaleKundeEndDate"] ? new Date(_data["aftaleKundeEndDate"].toString()) : <any>undefined;
            this.endOfLateSignUpPeriod = _data["endOfLateSignUpPeriod"] ? new Date(_data["endOfLateSignUpPeriod"].toString()) : <any>undefined;
            this.expirationDateMaxUtc = _data["expirationDateMaxUtc"] ? new Date(_data["expirationDateMaxUtc"].toString()) : <any>undefined;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.agreementName = _data["agreementName"];
            this.customerCvr = _data["customerCvr"];
            this.customerOrgId = _data["customerOrgId"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.agreementGuid = _data["agreementGuid"];
        }
    }

    static fromJS(data: any): TrafficLightOutputDto {
        data = typeof data === 'object' ? data : {};
        let result = new TrafficLightOutputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["applicationType"] = this.applicationType;
        data["applicationLabel"] = this.applicationLabel;
        data["applicationDescription"] = this.applicationDescription;
        data["conditionsDescription"] = this.conditionsDescription;
        data["selectedApplicationOption"] = this.selectedApplicationOption;
        data["agreementId"] = this.agreementId;
        data["mainAgreementGuid"] = this.mainAgreementGuid;
        data["aftaleKundeStartDate"] = this.aftaleKundeStartDate ? this.aftaleKundeStartDate.toISOString() : <any>undefined;
        data["aftaleKundeEndDate"] = this.aftaleKundeEndDate ? this.aftaleKundeEndDate.toISOString() : <any>undefined;
        data["endOfLateSignUpPeriod"] = this.endOfLateSignUpPeriod ? this.endOfLateSignUpPeriod.toISOString() : <any>undefined;
        data["expirationDateMaxUtc"] = this.expirationDateMaxUtc ? this.expirationDateMaxUtc.toISOString() : <any>undefined;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["agreementName"] = this.agreementName;
        data["customerCvr"] = this.customerCvr;
        data["customerOrgId"] = this.customerOrgId;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["agreementGuid"] = this.agreementGuid;
        return data;
    }
}

export interface ITrafficLightOutputDto {
    applicationType?: string;
    applicationLabel?: string;
    applicationDescription?: string;
    conditionsDescription?: string;
    selectedApplicationOption?: string;
    agreementId?: string;
    mainAgreementGuid?: string | undefined;
    aftaleKundeStartDate?: Date | undefined;
    aftaleKundeEndDate?: Date | undefined;
    endOfLateSignUpPeriod?: Date | undefined;
    expirationDateMaxUtc?: Date | undefined;
    startDate?: Date | undefined;
    endDate?: Date | undefined;
    agreementName?: string;
    customerCvr?: string;
    customerOrgId?: string;
    customerId?: string;
    customerName?: string;
    agreementGuid?: string;

    [key: string]: any;
}

export enum Classes {
    _0 = 0,
    _971410000 = 971410000,
    _971410001 = 971410001,
}

export enum DocumentAuthorizationUnauthorizedReason {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
}

export enum HealthCheckResultStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export enum StatusUpdateProgressStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6,
    _7 = 7,
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}